// Code generated by the Encore v1.58.4 client generator. DO NOT EDIT.

// Disable eslint, jshint, and jslint for this file.
/* eslint-disable */
/* jshint ignore:start */
/*jslint-disable*/

/**
 * BaseURL is the base URL for calling the Encore application's API.
 */
export type BaseURL = string

export const Local: BaseURL = "http://localhost:4000"

/**
 * Environment returns a BaseURL for calling the cloud environment with the given name.
 */
export function Environment(name: string): BaseURL {
    return `https://${name}-zac-2w8i.encr.app`
}

/**
 * PreviewEnv returns a BaseURL for calling the preview environment with the given PR number.
 */
export function PreviewEnv(pr: number | string): BaseURL {
    return Environment(`pr${pr}`)
}

const BROWSER = typeof globalThis === "object" && ("window" in globalThis);

/**
 * Client is an API client for the zac-2w8i Encore application.
 */
export default class Client {
    public readonly auth: auth.ServiceClient
    public readonly billing: billing.ServiceClient
    public readonly browser: browser.ServiceClient
    public readonly chat: chat.ServiceClient
    public readonly connection: connection.ServiceClient
    public readonly database: database.ServiceClient
    public readonly evaluations: evaluations.ServiceClient
    public readonly events: events.ServiceClient
    public readonly execution: execution.ServiceClient
    public readonly experiments: experiments.ServiceClient
    public readonly graph_config: graph_config.ServiceClient
    public readonly guides: guides.ServiceClient
    public readonly mcp_zoom: mcp_zoom.ServiceClient
    public readonly memory: memory.ServiceClient
    public readonly plans: plans.ServiceClient
    public readonly repl: repl.ServiceClient
    public readonly validation: validation.ServiceClient
    public readonly zoom: zoom.ServiceClient
    public readonly zoom_map: zoom_map.ServiceClient
    private readonly options: ClientOptions
    private readonly target: string


    /**
     * Creates a Client for calling the public and authenticated APIs of your Encore application.
     *
     * @param target  The target which the client should be configured to use. See Local and Environment for options.
     * @param options Options for the client
     */
    constructor(target: BaseURL, options?: ClientOptions) {
        this.target = target
        this.options = options ?? {}
        const base = new BaseClient(this.target, this.options)
        this.auth = new auth.ServiceClient(base)
        this.billing = new billing.ServiceClient(base)
        this.browser = new browser.ServiceClient(base)
        this.chat = new chat.ServiceClient(base)
        this.connection = new connection.ServiceClient(base)
        this.database = new database.ServiceClient(base)
        this.evaluations = new evaluations.ServiceClient(base)
        this.events = new events.ServiceClient(base)
        this.execution = new execution.ServiceClient(base)
        this.experiments = new experiments.ServiceClient(base)
        this.graph_config = new graph_config.ServiceClient(base)
        this.guides = new guides.ServiceClient(base)
        this.mcp_zoom = new mcp_zoom.ServiceClient(base)
        this.memory = new memory.ServiceClient(base)
        this.plans = new plans.ServiceClient(base)
        this.repl = new repl.ServiceClient(base)
        this.validation = new validation.ServiceClient(base)
        this.zoom = new zoom.ServiceClient(base)
        this.zoom_map = new zoom_map.ServiceClient(base)
    }

    /**
     * Creates a new Encore client with the given client options set.
     *
     * @param options Client options to set. They are merged with existing options.
     **/
    public with(options: ClientOptions): Client {
        return new Client(this.target, {
            ...this.options,
            ...options,
        })
    }
}

/**
 * ClientOptions allows you to override any default behaviour within the generated Encore client.
 */
export interface ClientOptions {
    /**
     * By default the client will use the inbuilt fetch function for making the API requests.
     * however you can override it with your own implementation here if you want to run custom
     * code on each API request made or response received.
     */
    fetcher?: Fetcher

    /** Default RequestInit to be used for the client */
    requestInit?: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }

    /**
     * Allows you to set the authentication data to be used for each
     * request either by passing in a static object or by passing in
     * a function which returns a new object for each request.
     */
    auth?: auth.AuthParams | AuthDataGenerator
}

/**
 * Auth service handles authentication and tenant isolation
 */
export namespace auth {
    /**
     * Parameters extracted from the request for auth
     */
    export interface AuthParams {
        authorization: string
        tenantId?: string
    }

    export interface AuthUser {
        id: string
        email: string
        name: string | null
        avatarUrl: string | null
        hasCompletedOnboarding: boolean
    }

    export interface GetMeResponse {
        user: AuthUser
        tenantId: string
        zoom: {
            connected: boolean
            accountName?: string
            accountId?: string
        }
        browser: {
            connected: boolean
            zoomSignedIn: boolean
            url?: string
        }
        plan: string
        subscriptionStatus: string | null
        trialEnd: string | null
        /**
         * Platform admin (users.is_admin) — gates the admin dashboard.
         */
        isAdmin: boolean
    }

    export interface OtpRequestParams {
        email: string
    }

    export interface OtpRequestResponse {
        success: boolean
        message: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.completeOnboarding = this.completeOnboarding.bind(this)
            this.getGoogleAuthUrl = this.getGoogleAuthUrl.bind(this)
            this.getMe = this.getMe.bind(this)
            this.googleCallback = this.googleCallback.bind(this)
            this.logout = this.logout.bind(this)
            this.refresh = this.refresh.bind(this)
            this.requestOtp = this.requestOtp.bind(this)
            this.sessionStatus = this.sessionStatus.bind(this)
            this.verifyOtpEndpoint = this.verifyOtpEndpoint.bind(this)
        }

        public async completeOnboarding(): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/onboarding-complete`)
            return await resp.json() as {
    success: boolean
}
        }

        public async getGoogleAuthUrl(): Promise<{
    url: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/auth/google/url`)
            return await resp.json() as {
    url: string
}
        }

        public async getMe(): Promise<GetMeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/auth/me`)
            return await resp.json() as GetMeResponse
        }

        public async googleCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/google/callback`, body, options)
        }

        public async logout(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/logout`, body, options)
        }

        public async refresh(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/refresh`, body, options)
        }

        public async requestOtp(params: OtpRequestParams): Promise<OtpRequestResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/otp/request`, JSON.stringify(params))
            return await resp.json() as OtpRequestResponse
        }

        public async sessionStatus(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/session-status`, body, options)
        }

        public async verifyOtpEndpoint(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/otp/verify`, body, options)
        }
    }
}

export namespace billing {
    export interface BillingConfigResponse {
        publishableKey: string
    }

    export interface BillingEventEntry {
        id: string
        userId: string
        userEmail: string
        tenantId: string
        stripeEventId: string
        eventType: string
        payload: { [key: string]: any }
        createdAt: string
    }

    export interface BillingStatusResponse {
        /**
         * false while billing is switched off (billing/lib/billing-switch.ts): no gates, no Stripe.
         */
        billingEnabled: boolean

        plan: PlanId
        subscriptionStatus: SubscriptionStatus | null
        seats: number
        currentPeriodEnd: string | null
        trialEnd: string | null
        cancelAtPeriodEnd: boolean
        features: PlanFeatures
    }

    export interface CancelSubscriptionResponse {
        cancelAtPeriodEnd: boolean
        currentPeriodEnd: string
    }

    export interface CreateEmbeddedCheckoutRequest {
        seats: number
        annual: boolean
        returnUrl: string
    }

    export interface CreateEmbeddedCheckoutResponse {
        clientSecret: string
    }

    export interface Invoice {
        id: string
        date: string
        amount: number
        status: string
        pdfUrl: string | null
        hostedUrl: string | null
    }

    export interface InvoicesResponse {
        invoices: Invoice[]
    }

    export interface ListBillingEventsRequest {
        userId?: string
        eventType?: string
        dateFrom?: string
        dateTo?: string
        limit?: number
        offset?: number
    }

    export interface ListBillingEventsResponse {
        events: BillingEventEntry[]
        total: number
        hasMore: boolean
    }

    export interface PaymentMethod {
        brand: string
        last4: string
        expMonth: number
        expYear: number
    }

    export interface PaymentMethodResponse {
        paymentMethod: PaymentMethod | null
    }

    export interface PlanFeatures {
        zoomConnect: boolean
        accountAnswers: boolean
        healthCheck: boolean
        licenseReport: boolean
        nlConfig: boolean
        bulkChanges: boolean
        auditTrail: boolean
        unlimitedAdminUsers: boolean
    }

    export type PlanId = "free" | "pro"

    export interface ReactivateSubscriptionResponse {
        cancelAtPeriodEnd: boolean
    }

    export interface SetupIntentResponse {
        clientSecret: string
    }

    export type SubscriptionStatus = "active" | "trialing" | "past_due" | "canceled" | "incomplete" | "incomplete_expired" | "unpaid" | "paused"

    export interface UpdatePaymentMethodRequest {
        paymentMethodId: string
    }

    export interface UpdatePaymentMethodResponse {
        success: boolean
    }

    export interface UpdateSeatsRequest {
        seats: number
    }

    export interface UpdateSeatsResponse {
        seats: number
        prorationAmount: number | null
    }

    export interface VerifySessionRequest {
        sessionId: string
    }

    export interface VerifySessionResponse {
        activated: boolean
        plan: PlanId
        subscriptionStatus: string | null
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.cancelSubscription = this.cancelSubscription.bind(this)
            this.createEmbeddedCheckout = this.createEmbeddedCheckout.bind(this)
            this.createSetupIntent = this.createSetupIntent.bind(this)
            this.getConfig = this.getConfig.bind(this)
            this.getPaymentMethod = this.getPaymentMethod.bind(this)
            this.getStatus = this.getStatus.bind(this)
            this.listBillingEvents = this.listBillingEvents.bind(this)
            this.listInvoices = this.listInvoices.bind(this)
            this.reactivateSubscription = this.reactivateSubscription.bind(this)
            this.updateDefaultPaymentMethod = this.updateDefaultPaymentMethod.bind(this)
            this.updateSeats = this.updateSeats.bind(this)
            this.verifySession = this.verifySession.bind(this)
            this.webhook = this.webhook.bind(this)
        }

        public async cancelSubscription(): Promise<CancelSubscriptionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/cancel`)
            return await resp.json() as CancelSubscriptionResponse
        }

        public async createEmbeddedCheckout(params: CreateEmbeddedCheckoutRequest): Promise<CreateEmbeddedCheckoutResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/checkout/embedded`, JSON.stringify(params))
            return await resp.json() as CreateEmbeddedCheckoutResponse
        }

        public async createSetupIntent(): Promise<SetupIntentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/setup-intent`)
            return await resp.json() as SetupIntentResponse
        }

        public async getConfig(): Promise<BillingConfigResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/billing/config`)
            return await resp.json() as BillingConfigResponse
        }

        public async getPaymentMethod(): Promise<PaymentMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/billing/payment-method`)
            return await resp.json() as PaymentMethodResponse
        }

        public async getStatus(): Promise<BillingStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/billing/status`)
            return await resp.json() as BillingStatusResponse
        }

        public async listBillingEvents(params: ListBillingEventsRequest): Promise<ListBillingEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                dateFrom:  params.dateFrom,
                dateTo:    params.dateTo,
                eventType: params.eventType,
                limit:     params.limit === undefined ? undefined : String(params.limit),
                offset:    params.offset === undefined ? undefined : String(params.offset),
                userId:    params.userId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/billing/events`, undefined, {query})
            return await resp.json() as ListBillingEventsResponse
        }

        public async listInvoices(): Promise<InvoicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/billing/invoices`)
            return await resp.json() as InvoicesResponse
        }

        public async reactivateSubscription(): Promise<ReactivateSubscriptionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/reactivate`)
            return await resp.json() as ReactivateSubscriptionResponse
        }

        public async updateDefaultPaymentMethod(params: UpdatePaymentMethodRequest): Promise<UpdatePaymentMethodResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/default-payment-method`, JSON.stringify(params))
            return await resp.json() as UpdatePaymentMethodResponse
        }

        public async updateSeats(params: UpdateSeatsRequest): Promise<UpdateSeatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/update-seats`, JSON.stringify(params))
            return await resp.json() as UpdateSeatsResponse
        }

        public async verifySession(params: VerifySessionRequest): Promise<VerifySessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/billing/verify-session`, JSON.stringify(params))
            return await resp.json() as VerifySessionResponse
        }

        public async webhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/billing/webhook`, body, options)
        }
    }
}

/**
 * Browser service manages browser delegation for admin portal automation.
 * Handles site discovery, snapshots, and action execution via Chrome extension.
 */
export namespace browser {
    export interface ActivateAppRequest {
        /**
         * Conversation to record the server-authored success line into.
         */
        conversationId?: string
    }

    export interface ActivateAppResponse {
        activated: boolean
        /**
         * Zoom's own blocker list, verbatim, when activation is refused.
         */
        blockers?: string[]

        error?: string
    }

    export interface AddAppScopesRequest {
        /**
         * Scope ids to tick. When given, this exact list is used (the enable-write
         * flow passes the write scopes); otherwise the core read scopes, plus the
         * core write scopes when `write` is true (a "Read + write" setup).
         */
        scopes?: string[]

        /**
         * Add the write scopes along with the read scopes.
         */
        write?: boolean

        /**
         * Conversation to record the server-authored success line into.
         */
        conversationId?: string

        /**
         * The plan the scopes are added for: its revert offers to take them back off the app (R3.7).
         */
        "plan_id"?: string

        /**
         * The scopes of `scopes` the plan itself asked for; the rest (the core write set a read-only tenant also gets) are not the plan's.
         */
        "plan_scopes"?: string[]
    }

    export interface AddAppScopesResponse {
        /**
         * Scopes newly ticked in the modal this run.
         */
        added: string[]

        /**
         * Scopes whose checkbox was already checked (idempotent re-run).
         */
        alreadyPresent: string[]

        /**
         * Scopes whose row couldn't be found/ticked — the search-and-tick missed.
         */
        failed: string[]

        error?: string
    }

    export interface CaptureAppCredentialsRequest {
        /**
         * 'reader' (default) | 'writer' — which app slot these creds fill.
         */
        purpose?: "reader" | "writer"

        /**
         * The name the user gave the app during guided setup (passed from the FE,
         * which has it — more robust than scraping the editor header).
         */
        name?: string

        /**
         * Conversation to record the server-authored success line into.
         */
        conversationId?: string
    }

    export interface CaptureAppCredentialsResponse {
        captured: boolean
        accountId?: string
        /**
         * Masked — last 4 chars of the client_id only. Secret never returned.
         */
        clientIdLast4?: string

        error?: string
    }

    export interface CaptureZoomIdentityResponse {
        connected: boolean
        email?: string
        accountName?: string
        error?: string
    }

    export interface CreateS2sAppRequest {
        name: string
        /**
         * Conversation to record the server-authored success line into.
         */
        conversationId?: string
    }

    export interface CreateS2sAppResponse {
        created: boolean
        url: string
        error?: string
    }

    export interface FillAppInfoRequest {
        /**
         * Conversation to record the server-authored success line into.
         */
        conversationId?: string
    }

    export interface FillAppInfoResponse {
        filled: boolean
        /**
         * What was written (no secrets involved on this tab).
         */
        devName?: string

        devEmail?: string
        company?: string
        error?: string
    }

    export interface GetSessionResponse {
        enabled: boolean
        wsUrl?: string
        token?: string
        sessionId?: string
        viewport?: {
            width: number
            height: number
        }
    }

    export interface HarnessAuditEvent {
        /**
         * Epoch ms on the harness.
         */
        ts: number

        kind: string
        /**
         * The scoped user id the backend gave the harness: `<tenantId>:<userId>`.
         */
        userId?: string | null

        sessionId?: string | null
        detail?: { [key: string]: any }
    }

    export interface HarnessConcurrencyPoint {
        ts: number
        claimed: number
        /**
         * Sessions a backend driver holds.
         */
        leased: number

        viewers: number
    }

    export interface HarnessDashboardRequest {
        windowMinutes?: number
    }

    export interface HarnessDashboardResponse {
        /**
         * False when BrowserHarnessUrl is unset — the backend has no harness to ask.
         */
        configured: boolean

        reachable: boolean
        error: string | null
        service: {
            env: string
            bootedAt: number
            chromiumImage: string
            maxSessions: number
            idleTimeoutMs: number
            containerMemoryBytes: number
        } | null
        pool: {
            claimed: number
            cap: number
            draining: boolean
        } | null
        current: HarnessConcurrencyPoint | null
        sessions: HarnessDashboardSession[]
        history: HarnessConcurrencyPoint[]
    }

    export interface HarnessDashboardSession {
        owner: HarnessSessionOwner
        sessionId: string
        /**
         * `<tenantId>:<userId>`.
         */
        userId: string

        state: "claimed" | "stopping"
        containerId: string
        hostPort: number
        createdAt: number
        lastActivity: number
        subscribers: number
        screencasting: boolean
        url: string
        viewport: {
            width: number
            height: number
        }
        usage: HarnessSessionUsage | null
        /**
         * The backend driver holding the tab ('execution', 'plans', 'guided-setup', 'teleport').
         */
        lease: {
            owner: string
            expiresAt: number
        } | null

        /**
         * Adopted across a deploy on an older Chromium image; replaced at its next idle window.
         */
        staleImage: boolean
    }

    export interface HarnessHandshake {
        /**
         * Unused. Present because Encore requires a non-empty handshake schema.
         */
        client?: string
    }

    export interface HarnessLogEntry {
        id: string
        /**
         * The harness's audit kind: session_claimed, action, stream_connected, …
         */
        kind: string

        createdAt: string
        tenantId: string
        tenantName: string | null
        userId: string | null
        email: string | null
        sessionId: string | null
        data: { [key: string]: any }
    }

    export interface HarnessLogRequest {
        /**
         * One session's log: its events plus its container's (matched on containerId).
         */
        sessionId?: string

        containerId?: string
        limit?: number
    }

    export interface HarnessLogResponse {
        entries: HarnessLogEntry[]
    }

    export interface HarnessSessionOwner {
        tenantId: string
        tenantName: string | null
        userId: string | null
        email: string | null
        name: string | null
    }

    export interface HarnessSessionUsage {
        memBytes: number
        memLimitBytes: number
        /**
         * % of one core; null until the harness has two readings.
         */
        cpuPct: number | null

        pids: number
        sampledAt: number
    }

    export interface HarnessStatusMessage {
        type: "init" | "status"
        connected: boolean
    }

    export interface IngestHarnessEventsRequest {
        secret: string
        events: HarnessAuditEvent[]
    }

    export interface IngestHarnessEventsResponse {
        accepted: number
    }

    export interface ReleaseSessionResponse {
        released: boolean
    }

    export interface RemoveAppScopesRequest {
        /**
         * The scopes to take off the app.
         */
        scopes: string[]
    }

    export interface RemoveAppScopesResponse {
        /**
         * Scopes unticked this run.
         */
        removed: string[]

        /**
         * Scopes the app did not hold.
         */
        absent: string[]

        failed: string[]
        error?: string
    }

    export interface TakeOverResponse {
        /**
         * True when a driver held the tab and lost it to the user.
         */
        released: boolean
    }

    export interface ZoomAuthStateResponse {
        enabled: boolean
        /**
         * True only when the marketplace chrome is fully rendered AND shows no
         * sign-in affordance (i.e. signed in). Never inferred from a half-rendered
         * page — see pageReady.
         */
        signedIn: boolean

        /**
         * True when a "Sign in"/"Sign up" affordance is present (logged out).
         */
        signinPresent: boolean

        /**
         * True when the marketplace top-nav chrome (search box / Develop menu /
         * logo) has actually rendered and the document is loaded. When false the
         * page is still hydrating, so neither signedIn nor signinPresent is
         * trustworthy — callers must treat the verdict as "unknown" and keep
         * polling rather than acting. This is what stops a false takeover on a
         * mid-load page (the "Conjuring your app..." window).
         */
        pageReady: boolean

        url: string
        /**
         * True when on the marketplace "create app" surface.
         */
        onCreatePage: boolean

        /**
         * True when the Server-to-Server OAuth radio is present on the create page.
         */
        s2sFound: boolean

        /**
         * True when S2S is present but DISABLED — the account lacks the S2S
         * privilege (Owner/Admin role), so it can't be created.
         */
        s2sBlocked: boolean

        /**
         * True when the "Name your app" field is present (the post-Create step).
         */
        onNameStep: boolean
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.activateApp = this.activateApp.bind(this)
            this.addAppScopes = this.addAppScopes.bind(this)
            this.captureAppCredentials = this.captureAppCredentials.bind(this)
            this.captureZoomIdentity = this.captureZoomIdentity.bind(this)
            this.createS2sApp = this.createS2sApp.bind(this)
            this.fillAppInfo = this.fillAppInfo.bind(this)
            this.getAdminEntities = this.getAdminEntities.bind(this)
            this.getAdminNavTree = this.getAdminNavTree.bind(this)
            this.getBrowserTabs = this.getBrowserTabs.bind(this)
            this.getHarnessDashboard = this.getHarnessDashboard.bind(this)
            this.getHarnessLog = this.getHarnessLog.bind(this)
            this.getSession = this.getSession.bind(this)
            this.getZoomAuthState = this.getZoomAuthState.bind(this)
            this.harnessStatusStream = this.harnessStatusStream.bind(this)
            this.ingestHarnessEvents = this.ingestHarnessEvents.bind(this)
            this.releaseSessionEndpoint = this.releaseSessionEndpoint.bind(this)
            this.removeAppScopes = this.removeAppScopes.bind(this)
            this.switchBrowserTab = this.switchBrowserTab.bind(this)
            this.takeOverSession = this.takeOverSession.bind(this)
        }

        /**
         * Drive the Activation tab. Idempotent: an already-active app reports
         * activated=true. When Zoom refuses, its requirement list ("1. Developer
         * contact name…") is returned verbatim so the chat can say exactly what's
         * missing instead of a generic failure.
         */
        public async activateApp(params: ActivateAppRequest): Promise<ActivateAppResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-activate-app`, JSON.stringify(params))
            return await resp.json() as ActivateAppResponse
        }

        /**
         * Drive the Add-Scopes modal: open it, then for each requested scope search by
         * its exact id and tick the matching checkbox. The scope lists are backend
         * knowledge (zoom/granular-*-scopes.ts); the frontend only says read or
         * read + write. Selector-interim (the modal DOM
         * has no data-eng export yet) with per-step diag logging so any miss
         * self-reports — same drive-and-diag pattern that landed the credential read.
         * Idempotent: already-checked scopes are skipped; partial success is fine
         * (verify diffs granted-vs-requested afterward).
         */
        public async addAppScopes(params: AddAppScopesRequest): Promise<AddAppScopesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-add-scopes`, JSON.stringify(params))
            return await resp.json() as AddAppScopesResponse
        }

        public async captureAppCredentials(params: CaptureAppCredentialsRequest): Promise<CaptureAppCredentialsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-capture-credentials`, JSON.stringify(params))
            return await resp.json() as CaptureAppCredentialsResponse
        }

        public async captureZoomIdentity(): Promise<CaptureZoomIdentityResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-capture-identity`)
            return await resp.json() as CaptureZoomIdentityResponse
        }

        public async createS2sApp(params: CreateS2sAppRequest): Promise<CreateS2sAppResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-create-s2s-app`, JSON.stringify(params))
            return await resp.json() as CreateS2sAppResponse
        }

        /**
         * Fill the Information tab's activation-required fields: developer contact
         * name + email (the signed-in user) and company name (the tenant). Zoom's
         * Activation tab lists exactly these as blockers — an app whose Information
         * tab is empty can never be activated, so no token can ever mint (found via
         * the s2s_app_creation.xml export). Idempotent: values are overwritten.
         */
        public async fillAppInfo(params: FillAppInfoRequest): Promise<FillAppInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-fill-app-info`, JSON.stringify(params))
            return await resp.json() as FillAppInfoResponse
        }

        /**
         * Returns every domain entity discovered during admin portal crawls. Each
         * entity carries its operations (list/create/update/delete), list columns,
         * relationships to other entities, and the URL/heading where it was found.
         * Backs the Entity Schema admin view. Public (no auth) — this is shared
         * reference data, not tenant-scoped.
         */
        public async getAdminEntities(): Promise<{
    entities: {
        entityName: string
        entityPlural: string
        operations: string[]
        listColumns: string[]
        relatedTo: {
            entity: string
            field: string
            relationship: string
        }[] | null
        url: string
        heading: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/admin/entities`)
            return await resp.json() as {
    entities: {
        entityName: string
        entityPlural: string
        operations: string[]
        listColumns: string[]
        relatedTo: {
            entity: string
            field: string
            relationship: string
        }[] | null
        url: string
        heading: string
    }[]
}
        }

        /**
         * Returns the full navigation tree of discovered admin pages: each page with
         * its nav-path breadcrumbs, heading, entity binding, active tab, and revealed
         * actions (state transitions). Backs the Nav Tree admin view. Public (no
         * auth) — shared reference data, not tenant-scoped.
         */
        public async getAdminNavTree(): Promise<{
    pages: {
        id: string
        url: string
        navPath: string[]
        heading: string
        description: string
        entityName: string
        entityPlural: string
        entityOperations: string[]
        activeTab: string | null
        tabs: string[] | null
        actions: {
            id: string
            triggerLabel: string
            outcome: string
            revealed: { [key: string]: any } | null
        }[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/admin/nav-tree`)
            return await resp.json() as {
    pages: {
        id: string
        url: string
        navPath: string[]
        heading: string
        description: string
        entityName: string
        entityPlural: string
        entityOperations: string[]
        activeTab: string | null
        tabs: string[] | null
        actions: {
            id: string
            triggerLabel: string
            outcome: string
            revealed: { [key: string]: any } | null
        }[]
    }[]
}
        }

        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        public async getBrowserTabs(): Promise<{
    /**
     * Returns the open tabs on the user's harness Chromium with URL, title, and
     * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
     * alongside WS-driven URL-change events. Authenticated — scoped to the
     * caller's session.
     */
    tabs: {
        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        url: string

        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        title: string

        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        isActive: boolean
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/tabs`)
            return await resp.json() as {
    /**
     * Returns the open tabs on the user's harness Chromium with URL, title, and
     * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
     * alongside WS-driven URL-change events. Authenticated — scoped to the
     * caller's session.
     */
    tabs: {
        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        url: string

        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        title: string

        /**
         * Returns the open tabs on the user's harness Chromium with URL, title, and
         * active flag. Frontend BrowserPanel uses this as a 30s safety-net poll
         * alongside WS-driven URL-change events. Authenticated — scoped to the
         * caller's session.
         */
        isActive: boolean
    }[]
}
        }

        /**
         * The harness right now: pool, every session with its owner and container usage, and history.
         */
        public async getHarnessDashboard(params: HarnessDashboardRequest): Promise<HarnessDashboardResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                windowMinutes: params.windowMinutes === undefined ? undefined : String(params.windowMinutes),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/admin/harness`, undefined, {query})
            return await resp.json() as HarnessDashboardResponse
        }

        /**
         * The harness's recent log (last 24h, newest first), for every session or one.
         */
        public async getHarnessLog(params: HarnessLogRequest): Promise<HarnessLogResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                containerId: params.containerId,
                limit:       params.limit === undefined ? undefined : String(params.limit),
                sessionId:   params.sessionId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/admin/harness/log`, undefined, {query})
            return await resp.json() as HarnessLogResponse
        }

        /**
         * Frontend calls this to obtain a WS URL + short-lived token for a
         * per-user Chromium session on the browser-harness. Falls back to
         * `{enabled: false}` when the service URL isn't configured — frontend
         * should then use the legacy /browser/stream path.
         */
        public async getSession(): Promise<GetSessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/service-session`)
            return await resp.json() as GetSessionResponse
        }

        public async getZoomAuthState(): Promise<ZoomAuthStateResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/zoom-auth-state`)
            return await resp.json() as ZoomAuthStateResponse
        }

        /**
         * Harness status stream — lightweight, authenticated WS that reports
         * whether the sidecar Chrome CDP is reachable. Independent of whether the
         * browser panel is open. Drives the top-right "Browser Harness Connected"
         * pill in the chat UI. Sends an initial `{type: 'init', connected}` then
         * pushes `{type: 'status', connected}` on every state change plus a 30s
         * heartbeat.
         */
        public async harnessStatusStream(params: HarnessHandshake): Promise<StreamIn<HarnessStatusMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                client: params.client,
            })

            return await this.baseClient.createStreamIn(`/browser/harness-stream`, {query})
        }

        /**
         * Called by the browser-harness only (shared-secret auth), never by a browser.
         */
        public async ingestHarnessEvents(params: IngestHarnessEventsRequest): Promise<IngestHarnessEventsResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                "x-internal-secret": params.secret,
            })

            // Construct the body with only the fields which we want encoded within the body (excluding query string or header fields)
            const body: Record<string, any> = {
                events: params.events,
            }

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/harness/events`, JSON.stringify(body), {headers})
            return await resp.json() as IngestHarnessEventsResponse
        }

        /**
         * Frontend calls this when the user leaves the chat surface so their
         * Chromium container is freed up on the harness service. Releases the
         * harness session. Idempotent — safe to call when no session exists.
         */
        public async releaseSessionEndpoint(): Promise<ReleaseSessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/browser/service-session`)
            return await resp.json() as ReleaseSessionResponse
        }

        /**
         * The add step in reverse (R3.7): the Add-Scopes modal, each scope's checkbox cleared, Done. The connection step
         * (connection/s2s-remove-scopes.ts) chooses the scopes, activates and re-mints.
         */
        public async removeAppScopes(params: RemoveAppScopesRequest): Promise<RemoveAppScopesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/zoom-remove-scopes`, JSON.stringify(params))
            return await resp.json() as RemoveAppScopesResponse
        }

        /**
         * Switches the active tab on the user's harness Chromium to the given index.
         * Restarts the screencast on success so the next frame is emitted from the
         * new tab's CDP session. Authenticated.
         */
        public async switchBrowserTab(params: {
    /**
     * Switches the active tab on the user's harness Chromium to the given index.
     * Restarts the screencast on success so the next frame is emitted from the
     * new tab's CDP session. Authenticated.
     */
    index: number
}): Promise<{
    /**
     * Switches the active tab on the user's harness Chromium to the given index.
     * Restarts the screencast on success so the next frame is emitted from the
     * new tab's CDP session. Authenticated.
     */
    switched: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/tabs/switch`, JSON.stringify(params))
            return await resp.json() as {
    /**
     * Switches the active tab on the user's harness Chromium to the given index.
     * Restarts the screencast on success so the next frame is emitted from the
     * new tab's CDP session. Authenticated.
     */
    switched: boolean
}
        }

        /**
         * The panel's "Take over": break whatever lease holds the user's tab. The
         * driver (a recipe run, a guided-setup step) stops before its next step and
         * the harness relays the user's input again. Idempotent.
         */
        public async takeOverSession(): Promise<TakeOverResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/session/take-over`)
            return await resp.json() as TakeOverResponse
        }
    }
}

/**
 * User-facing entry point for the ZAC chat experience.
 * 
 * Owns WebSocket streaming, conversation CRUD, rate limiting, and auth.
 * Delegates all AI reasoning to brain/ via Encore streaming clients.
 * Exposes internal APIs for brain/ to read/write conversations and messages.
 * Provides KB search access for quality/fitness evaluations.
 */
export namespace chat {
    export interface AppendMessageRequest {
        /**
         * Client may only append its OWN ('user') turns. Assistant rows are
         * written server-side (streaming replies by brain/llm-session, wizard
         * narration by browser/intro-api) so a client can never forge them.
         */
        role: "user"

        content: string
    }

    export interface AppendMessageResponse {
        id: string
    }

    /**
     * Live browser events (for 'progress' type): ZAC driving the harness, and
     * the user asking to show/hide the browser panel.
     */
    export interface BrowserProgress {
        phase: "browser-driving" | "browser-driving-done" | "browser-panel"
        /**
         * Overlay label while ZAC drives ('browser-driving').
         */
        status?: string

        /**
         * Show (true) or hide (false) the browser panel ('browser-panel').
         */
        visible?: boolean
    }

    export interface ChatStreamRequest {
        conversationId: string
        message: string
        /**
         * Whether the browser panel is showing in the user's chat right now —
         * a hidden panel makes "change X" ambiguous (watch, or just do it?).
         */
        browserVisible?: boolean
    }

    /**
     * Citation for sourcing AI responses
     */
    export interface Citation {
        url: string
        title: string
        snippet?: string
        confidence: number
        sourceType: "kb_article" | "api_docs" | "release_note" | "product_page" | "pricing_page"
        extractedAt?: string
    }

    export interface Conversation {
        id: string
        tenantId: string
        userId: string
        title?: string
        createdAt: string
        updatedAt: string
        messageCount?: number
        lastMessage?: string
    }

    export interface CreateConversationRequest {
        title?: string
    }

    export interface CreateConversationResponse {
        id: string
        conversation: Conversation
    }

    export interface DeleteConversationResponse {
        success: boolean
    }

    /**
     * A request being read as the chat's card follows it (plans/document/chat-card.ts; docs/plans/chat-on-document-pipeline.md).
     */
    export interface DocumentCardSummary {
        /**
         * The request document's id.
         */
        id: string

        title: string
    }

    export interface GetConversationResponse {
        conversation: Conversation
        messages: Message[]
    }

    /**
     * Interactive mode indicator for frontend to render options as buttons
     */
    export interface InteractiveMode {
        /**
         * Type of interaction
         */
        type: "choice" | "confirm" | "input"

        /**
         * Prompt text shown above options
         */
        prompt?: string

        /**
         * Available options (for choice type)
         */
        options?: InteractiveOption[]

        /**
         * Whether multiple selections are allowed
         */
        multiSelect?: boolean

        /**
         * The request the card follows: the app polls it, shows its questions, then its plan.
         */
        document?: DocumentCardSummary
    }

    /**
     * Interactive option for rendering as clickable button
     */
    export interface InteractiveOption {
        id: string
        label: string
        description?: string
        /**
         * Value to send back when selected
         */
        value: string

        /**
         * Optional icon hint for frontend
         */
        icon?: "plan" | "quick" | "manual" | "product" | "confirm" | "cancel" | "element" | "watch"

        /**
         * Shown but not selectable; `hint` says why.
         */
        disabled?: boolean

        hint?: string
        /**
         * The option the user is steered to.
         */
        highlight?: boolean
    }

    export interface ListConversationsRequest {
        limit?: number
        offset?: number
    }

    export interface ListConversationsResponse {
        items: Conversation[]
        total: number
        hasMore: boolean
    }

    export interface Message {
        id: string
        conversationId: string
        role: MessageRole
        content: string
        artifacts?: shared.Artifact[]
        citations?: Citation[]
        productContext?: string
        createdAt: string
    }

    export type MessageRole = "user" | "assistant" | "system"

    export interface ProfileProgress {
        phase: "profiling"
        steps: ProfileStep[]
    }

    export interface ProfileStep {
        label: string
        status: "pending" | "in_progress" | "complete" | "error"
        detail?: string
    }

    /**
     * Why a stream ended.
     */
    export type StopReason = "end" | "error" | "cancelled"

    export interface StreamMessage {
        type: StreamMessageType
        /**
         * Interactive options (for 'interactive' type)
         */
        interactive?: InteractiveMode

        /**
         * Profile or browser progress (for 'progress' type)
         */
        progress?: ProfileProgress | BrowserProgress

        content?: string
        artifact?: shared.Artifact
        error?: string
        citations?: Citation[]
        /**
         * Server-issued assistant message id — on 'message_start', echoed on 'done'.
         */
        messageId?: string

        /**
         * Token accounting — on 'done'.
         */
        usage?: UsageInfo

        /**
         * Why the stream ended — on 'done'.
         */
        stopReason?: StopReason

        /**
         * Evaluation data (sent with 'done' message)
         */
        evaluationId?: string

        confidenceScore?: number
        confidenceRationale?: string
    }

    export type StreamMessageType = "message_start" | "token" | "artifact" | "done" | "error" | "thinking" | "interactive" | "progress"

    /**
     * Token accounting surfaced on the terminal 'done' envelope.
     */
    export interface UsageInfo {
        inputTokens: number
        outputTokens: number
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.appendMsg = this.appendMsg.bind(this)
            this.createConv = this.createConv.bind(this)
            this.deleteConv = this.deleteConv.bind(this)
            this.getConv = this.getConv.bind(this)
            this.listConvs = this.listConvs.bind(this)
            this.streamChat = this.streamChat.bind(this)
        }

        /**
         * Append a client-authored USER message to a conversation.
         * 
         * Why this exists: the guided-setup flow injects user turns client-side
         * (the app-name the user types, takeover acknowledgements) that previously
         * lived only in the Zustand store, so a hard reload — which re-fetches the
         * conversation from the DB — lost them. This persists those turns so the
         * setup transcript survives a reload.
         * 
         * Single-writer invariant: this endpoint is the ONLY client-facing write to
         * the transcript, and it is restricted to `role:'user'`. Assistant rows have
         * exactly two authors, both server-side — the streaming pipeline
         * (brain/llm-session → chat.addMsg) and the guided-setup steps
         * (browser/intro-api → chat.addMsg). A browser can therefore never inject a
         * forged assistant message. Ownership-guarded like getConv/deleteConv.
         */
        public async appendMsg(id: string, params: AppendMessageRequest): Promise<AppendMessageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/conversations/${encodeURIComponent(id)}/messages`, JSON.stringify(params))
            return await resp.json() as AppendMessageResponse
        }

        /**
         * Create a new conversation for the authenticated user. Returns the conversation ID and metadata.
         */
        public async createConv(params: CreateConversationRequest): Promise<CreateConversationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/conversations`, JSON.stringify(params))
            return await resp.json() as CreateConversationResponse
        }

        /**
         * Permanently delete a conversation and all its messages. Scoped to the user's tenant.
         */
        public async deleteConv(id: string): Promise<DeleteConversationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/chat/conversations/${encodeURIComponent(id)}`)
            return await resp.json() as DeleteConversationResponse
        }

        /**
         * Fetch a conversation by ID with its full message history. Scoped to the user's tenant.
         */
        public async getConv(id: string): Promise<GetConversationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/conversations/${encodeURIComponent(id)}`)
            return await resp.json() as GetConversationResponse
        }

        /**
         * List the authenticated user's conversations, ordered by most recent. Supports pagination via limit/offset.
         */
        public async listConvs(params: ListConversationsRequest): Promise<ListConversationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/conversations`, undefined, {query})
            return await resp.json() as ListConversationsResponse
        }

        /**
         * Stream AI responses to the user via WebSocket. Relays brain/ output in real-time with tokens, artifacts, interactive prompts, and progress updates. Rate-limited per user.
         */
        public async streamChat(params: ChatStreamRequest): Promise<StreamIn<StreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                browserVisible: params.browserVisible === undefined ? undefined : String(params.browserVisible),
                conversationId: params.conversationId,
                message:        params.message,
            })

            return await this.baseClient.createStreamIn(`/chat/stream`, {query})
        }
    }
}

/**
 * Connection service manages S2S OAuth credentials for connected Zoom accounts
 * Supports multi-tenant credential storage with encryption
 */
export namespace connection {
    export interface AllOAuthSettingsResponse {
        settings: OAuthAppSettings[]
    }

    export type AuthType = "oauth"

    export interface ConnectionCapabilities {
        canRead: boolean
        canWrite: boolean
        readCredentialId?: string
        writeCredentialId?: string
        accountNumber?: string
        organizationName?: string
    }

    export interface ConnectionStatusResponse {
        connected: boolean
        connection?: StoredConnection
    }

    export type CredentialPurpose = "general" | "reader" | "writer"

    export interface DisableWriteResponse {
        disabled: boolean
    }

    export interface DisconnectResponse {
        success: boolean
    }

    export interface EnableWriteRequest {
        /**
         * The write scopes to add: the core set when absent, or the ones a plan's API steps need (D7, "Add scopes").
         */
        scopes?: string[]

        /**
         * The plan they are added for: its revert offers to take them back off the app (R3.7).
         */
        "plan_id"?: string
    }

    export interface EnableWriteResponse {
        enabled: boolean
        /**
         * Already write-capable — nothing to do.
         */
        alreadyEnabled?: boolean

        grantedCount?: number
        /**
         * Requested write scopes Zoom did NOT grant (empty when fully granted).
         */
        missing?: string[]

        /**
         * Structured failure so the FE can react (e.g. open the harness to sign in).
         */
        error?: "harness_session_required" | "no_app" | "mint_failed" | "scope_add_failed"

        message?: string
    }

    export interface EnrichedAccount {
        /**
         * From stored connection
         */
        id: string

        accountId: string
        accountName: string
        authType: AuthType
        scopes: string[]
        connectedAt: string
        lastUsedAt?: string
        /**
         * From Zoom /users/me
         */
        email?: string

        displayName?: string
        picUrl?: string
        userType?: number
        userTypeName?: string
        roleName?: string
        planUnitedType?: string
        timezone?: string
        company?: string
        /**
         * Status
         */
        enrichmentStatus: "ok" | "token_expired" | "error"

        enrichmentError?: string
    }

    export interface GetZoomConnectUrlRequest {
        /**
         * Where to redirect after OAuth completes (e.g. "/settings"). Defaults to "/chat".
         */
        returnTo?: string

        /**
         * Which OAuth app to use: 'writer' (default) or 'reader'.
         */
        purpose?: string
    }

    export interface ListConnectionsResponse {
        connections: StoredConnection[]
    }

    export interface ListEnrichedAccountsResponse {
        accounts: EnrichedAccount[]
    }

    export interface OAuthAppSettings {
        id: string
        tenantId: string
        clientId: string
        redirectUri: string
        appPurpose: CredentialPurpose
        /**
         * Zoom account_id of the S2S app (for the account_credentials grant). Null
         * for legacy OAuth-app rows and any row created before Step-1 capture.
         */
        accountId: string | null

        /**
         * Display name the user gave the S2S app during guided setup. Null for
         * legacy rows.
         */
        appName: string | null

        /**
         * Marketplace app id from the editor URL (/develop/apps/<id>/...), captured
         * during Step-1 credential capture. Lets later guided steps navigate back
         * to the app editor. Null for legacy rows.
         */
        marketplaceAppId: string | null

        createdAt: string
        updatedAt: string
    }

    export interface OAuthSettingsRequest {
        clientId: string
        clientSecret: string
        redirectUri: string
        purpose?: CredentialPurpose
    }

    export interface OAuthSettingsResponse {
        settings: OAuthAppSettings | null
    }

    export interface RemoveScopesRequest {
        /**
         * Take back the scopes ZAC added for this plan.
         */
        "plan_id"?: string

        /**
         * Or these additions, by id.
         */
        "grant_ids"?: string[]
    }

    export interface RemoveScopesResponse {
        /**
         * Scopes cleared on the app.
         */
        removed: string[]

        /**
         * Scopes the additions held that another live addition still holds: left on the app.
         */
        kept: string[]

        /**
         * Scopes the harness could not clear.
         */
        failed: string[]

        error?: "nothing_to_remove" | "harness_session_required" | "no_app" | "scope_remove_failed"
        message?: string
    }

    export interface SaveOAuthSettingsResponse {
        success: boolean
        settings?: OAuthAppSettings
        error?: string
    }

    export interface SaveWebhookSettingsResponse {
        success: boolean
        settings?: WebhookSettings
        error?: string
    }

    export interface StartSidecarConnectRequest {
        /**
         * OAuth app selector: 'writer' (default) or 'reader'.
         */
        purpose?: string
    }

    export interface StoredConnection {
        id: string
        tenantId: string
        accountId: string
        accountName: string
        scopes: string[]
        authType: AuthType
        credentialPurpose: CredentialPurpose
        connectedAt: string
        lastUsedAt?: string
    }

    export interface UpdateSetupStateRequest {
        /**
         * Pass null to clear; omit to leave unchanged.
         */
        accessLevel?: CredentialPurpose | null

        conversationId?: string | null
    }

    export interface VerifyS2sConnectionResponse {
        verified: boolean
        grantedCount: number
        /**
         * Requested (core) read scopes Zoom did NOT grant (empty when fully granted).
         */
        missing: string[]

        /**
         * True when the tenant now has write access (a "Read + write" setup, promoted here).
         */
        canWrite: boolean

        /**
         * Requested write scopes Zoom did NOT grant; empty for a read-only setup or a full grant.
         */
        missingWrite: string[]

        error?: string
    }

    export interface WebhookEvent {
        id: string
        tenantId: string
        eventType: string
        eventTs: string
        accountId?: string
        payload: { [key: string]: any }
        processed: boolean
        processedAt?: string
        error?: string
        createdAt: string
    }

    export interface WebhookEventsResponse {
        events: WebhookEvent[]
    }

    export interface WebhookSettings {
        id: string
        tenantId: string
        webhookUrl: string
        verificationToken: string
        hasSecretToken: boolean
        enabled: boolean
        createdAt: string
        updatedAt: string
    }

    export interface WebhookSettingsRequest {
        webhookUrl: string
        verificationToken: string
        secretToken?: string
    }

    export interface WebhookSettingsResponse {
        settings: WebhookSettings | null
    }

    export interface ZoomSetupState {
        /**
         * 'reader' | 'writer' | null — the access level the user picked, if any.
         */
        accessLevel: CredentialPurpose | null

        /**
         * The conversation that holds the guided-setup chat, if started.
         */
        conversationId: string | null

        /**
         * Derived: the tenant has a usable read credential (app provisioned).
         */
        connected: boolean
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.deleteOAuthSettings = this.deleteOAuthSettings.bind(this)
            this.deleteWebhookSettingsEndpoint = this.deleteWebhookSettingsEndpoint.bind(this)
            this.disableWriteAccess = this.disableWriteAccess.bind(this)
            this.disconnect = this.disconnect.bind(this)
            this.disconnectAccount = this.disconnectAccount.bind(this)
            this.enableWriteAccess = this.enableWriteAccess.bind(this)
            this.getAllOAuthSettings = this.getAllOAuthSettings.bind(this)
            this.getCapabilities = this.getCapabilities.bind(this)
            this.getOAuthSettings = this.getOAuthSettings.bind(this)
            this.getOAuthUrl = this.getOAuthUrl.bind(this)
            this.getSetupState = this.getSetupState.bind(this)
            this.getStatus = this.getStatus.bind(this)
            this.getWebhookEvents = this.getWebhookEvents.bind(this)
            this.getWebhookSettingsEndpoint = this.getWebhookSettingsEndpoint.bind(this)
            this.getZoomConnectUrl = this.getZoomConnectUrl.bind(this)
            this.listAccounts = this.listAccounts.bind(this)
            this.listEnrichedAccounts = this.listEnrichedAccounts.bind(this)
            this.oauthCallback = this.oauthCallback.bind(this)
            this.removeAddedScopes = this.removeAddedScopes.bind(this)
            this.saveOAuthSettings = this.saveOAuthSettings.bind(this)
            this.saveWebhookSettingsEndpoint = this.saveWebhookSettingsEndpoint.bind(this)
            this.startSidecarConnect = this.startSidecarConnect.bind(this)
            this.updateSetupState = this.updateSetupState.bind(this)
            this.verifyS2sConnection = this.verifyS2sConnection.bind(this)
            this.webhookReceiver = this.webhookReceiver.bind(this)
            this.zoomConnectCallback = this.zoomConnectCallback.bind(this)
        }

        /**
         * Delete OAuth app settings for tenant
         */
        public async deleteOAuthSettings(params: {
    /**
     * Delete OAuth app settings for tenant
     */
    purpose?: CredentialPurpose
}): Promise<{
    /**
     * Delete OAuth app settings for tenant
     */
    success: boolean
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose: params.purpose === undefined ? undefined : String(params.purpose),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/connection/oauth-settings`, undefined, {query})
            return await resp.json() as {
    /**
     * Delete OAuth app settings for tenant
     */
    success: boolean
}
        }

        /**
         * Delete webhook settings for tenant
         */
        public async deleteWebhookSettingsEndpoint(): Promise<{
    /**
     * Delete webhook settings for tenant
     */
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/connection/webhook-settings`)
            return await resp.json() as {
    /**
     * Delete webhook settings for tenant
     */
    success: boolean
}
        }

        public async disableWriteAccess(): Promise<DisableWriteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/s2s/disable-write`)
            return await resp.json() as DisableWriteResponse
        }

        /**
         * Disconnect Zoom account
         */
        public async disconnect(): Promise<DisconnectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/disconnect`)
            return await resp.json() as DisconnectResponse
        }

        /**
         * Disconnect a specific account
         */
        public async disconnectAccount(accountId: string): Promise<DisconnectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/disconnect/${encodeURIComponent(accountId)}`)
            return await resp.json() as DisconnectResponse
        }

        public async enableWriteAccess(params: EnableWriteRequest): Promise<EnableWriteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/s2s/enable-write`, JSON.stringify(params))
            return await resp.json() as EnableWriteResponse
        }

        /**
         * Get all OAuth app settings for tenant (all purposes)
         */
        public async getAllOAuthSettings(): Promise<AllOAuthSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/oauth-settings/all`)
            return await resp.json() as AllOAuthSettingsResponse
        }

        /**
         * Get connection capabilities for tenant
         */
        public async getCapabilities(): Promise<ConnectionCapabilities> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/capabilities`)
            return await resp.json() as ConnectionCapabilities
        }

        /**
         * Get OAuth app settings for tenant (by purpose)
         */
        public async getOAuthSettings(params: {
    /**
     * Get OAuth app settings for tenant (by purpose)
     */
    purpose?: CredentialPurpose
}): Promise<OAuthSettingsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose: params.purpose === undefined ? undefined : String(params.purpose),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/oauth-settings`, undefined, {query})
            return await resp.json() as OAuthSettingsResponse
        }

        /**
         * Get OAuth authorization URL for tenant
         */
        public async getOAuthUrl(params: {
    /**
     * Get OAuth authorization URL for tenant
     */
    purpose?: CredentialPurpose
}): Promise<{
    /**
     * Get OAuth authorization URL for tenant
     */
    url: string | null

    /**
     * Get OAuth authorization URL for tenant
     */
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose: params.purpose === undefined ? undefined : String(params.purpose),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/oauth-url`, undefined, {query})
            return await resp.json() as {
    /**
     * Get OAuth authorization URL for tenant
     */
    url: string | null

    /**
     * Get OAuth authorization URL for tenant
     */
    error?: string
}
        }

        /**
         * Read the authenticated user's guided Zoom-setup state.
         */
        public async getSetupState(): Promise<ZoomSetupState> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/setup-state`)
            return await resp.json() as ZoomSetupState
        }

        /**
         * Get connection status
         */
        public async getStatus(): Promise<ConnectionStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/status`)
            return await resp.json() as ConnectionStatusResponse
        }

        /**
         * Get recent webhook events for tenant
         */
        public async getWebhookEvents(params: {
    /**
     * Get recent webhook events for tenant
     */
    limit?: number
}): Promise<WebhookEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/webhook-events`, undefined, {query})
            return await resp.json() as WebhookEventsResponse
        }

        /**
         * Get webhook settings for tenant
         */
        public async getWebhookSettingsEndpoint(): Promise<WebhookSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/webhook-settings`)
            return await resp.json() as WebhookSettingsResponse
        }

        public async getZoomConnectUrl(params: GetZoomConnectUrlRequest): Promise<{
    url: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose:  params.purpose,
                returnTo: params.returnTo,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/zoom/url`, undefined, {query})
            return await resp.json() as {
    url: string
}
        }

        /**
         * List all connected accounts for tenant
         */
        public async listAccounts(): Promise<ListConnectionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/accounts`)
            return await resp.json() as ListConnectionsResponse
        }

        /**
         * List all connected accounts enriched with live Zoom profile data
         */
        public async listEnrichedAccounts(): Promise<ListEnrichedAccountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/accounts/enriched`)
            return await resp.json() as ListEnrichedAccountsResponse
        }

        /**
         * OAuth callback handler - Zoom redirects here after authorization
         */
        public async oauthCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/connection/oauth/callback`, body, options)
        }

        public async removeAddedScopes(params: RemoveScopesRequest): Promise<RemoveScopesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/s2s/remove-scopes`, JSON.stringify(params))
            return await resp.json() as RemoveScopesResponse
        }

        /**
         * Save OAuth app settings for tenant
         */
        public async saveOAuthSettings(params: OAuthSettingsRequest): Promise<SaveOAuthSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/oauth-settings`, JSON.stringify(params))
            return await resp.json() as SaveOAuthSettingsResponse
        }

        /**
         * Save webhook settings for tenant
         */
        public async saveWebhookSettingsEndpoint(params: WebhookSettingsRequest): Promise<SaveWebhookSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/webhook-settings`, JSON.stringify(params))
            return await resp.json() as SaveWebhookSettingsResponse
        }

        public async startSidecarConnect(params: StartSidecarConnectRequest): Promise<{
    status: "initiated"
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/zoom/start-sidecar`, JSON.stringify(params))
            return await resp.json() as {
    status: "initiated"
}
        }

        /**
         * Persist the authenticated user's guided Zoom-setup progress (partial update).
         */
        public async updateSetupState(params: UpdateSetupStateRequest): Promise<ZoomSetupState> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/connection/setup-state`, JSON.stringify(params))
            return await resp.json() as ZoomSetupState
        }

        public async verifyS2sConnection(): Promise<VerifyS2sConnectionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/s2s/verify`)
            return await resp.json() as VerifyS2sConnectionResponse
        }

        /**
         * Webhook receiver endpoint for Zoom events
         * Tenant identified by ID in URL path
         */
        public async webhookReceiver(method: "POST", tenantId: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/connection/webhook/${encodeURIComponent(tenantId)}`, body, options)
        }

        public async zoomConnectCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/connection/zoom/callback`, body, options)
        }
    }
}

/**
 * Database service manages the central SQL database for ZAC
 * Stores conversations, plans, credentials, and tenant data
 */
export namespace database {
    export type AuditCategory = "api_read" | "api_write" | "browser" | "plan" | "error"

    export interface AuditLogEntry {
        id: string
        type: string
        category: AuditCategory
        method?: string
        endpoint?: string
        status?: number
        latencyMs?: number
        description: string
        userId?: string
        userEmail?: string
        conversationId?: string
        conversationTitle?: string
        createdAt: string
    }

    export interface AuditLogResponse {
        entries: AuditLogEntry[]
        total: number
        hasMore: boolean
    }

    export type CheckStatus = "ok" | "error"

    export interface EventLogEntry {
        id: string
        tenantId: string
        userId?: string
        eventType: string
        resourceType?: string
        resourceId?: string
        resourceName?: string
        details: { [key: string]: any }
        confirmationId?: string
        createdAt: string
    }

    /**
     * Event types from design doc
     */
    export type EventType = "zoom.change" | "zoom.drift" | "zoom.error" | "report.generated" | "access.write_enabled" | "access.write_disabled" | "access.scopes_removed" | "planning.plan_generated" | "planning.plan_reviewed" | "planning.plan_revised" | "planning.approved" | "planning.confirmed" | "planning.executed" | "planning.verified" | "planning.cancelled" | "planning.scheduled" | "planning.schedule_triggered" | "state.captured" | "state.restored" | "changeset.created" | "changeset.applied" | "changeset.copied" | "notification.sent" | "notification.failed" | "notification.webhook_delivered" | "notification.webhook_failed" | "synthetic.test_started" | "synthetic.test_completed" | "synthetic.test_failed" | "synthetic.test_error" | "synthetic.suite_completed"

    export interface HealthResponse {
        status: "ok" | "degraded"
        postgres: CheckStatus
        falkordb: CheckStatus
    }

    export interface ListEventsResponse {
        events: EventLogEntry[]
        total: number
        hasMore: boolean
    }

    export interface LogEventInput {
        tenantId: string
        userId?: string
        eventType: EventType
        resourceType?: string
        resourceId?: string
        resourceName?: string
        details?: { [key: string]: any }
        confirmationId?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.check = this.check.bind(this)
            this.createEvent = this.createEvent.bind(this)
            this.getAuditLog = this.getAuditLog.bind(this)
            this.getEventSummary = this.getEventSummary.bind(this)
            this.listEvents = this.listEvents.bind(this)
        }

        public async check(): Promise<HealthResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/health`)
            return await resp.json() as HealthResponse
        }

        /**
         * Log a new event
         */
        public async createEvent(params: LogEventInput): Promise<EventLogEntry> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/events`, JSON.stringify(params))
            return await resp.json() as EventLogEntry
        }

        /**
         * Get audit log of Zoom API and browser activity for the authenticated tenant
         */
        public async getAuditLog(params: {
    limit?: number
    offset?: number
    category?: string
}): Promise<AuditLogResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/audit/log`, undefined, {query})
            return await resp.json() as AuditLogResponse
        }

        /**
         * Get event type summary counts
         */
        public async getEventSummary(params: {
    tenantId?: string
}): Promise<{
    byType: {
        eventType: string
        count: number
    }[]
    total: number
    recentCount: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/summary`, undefined, {query})
            return await resp.json() as {
    byType: {
        eventType: string
        count: number
    }[]
    total: number
    recentCount: number
}
        }

        /**
         * List events with optional filters
         */
        public async listEvents(params: {
    tenantId?: string
    eventType?: string
    resourceType?: string
    limit?: number
    offset?: number
}): Promise<ListEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                eventType:    params.eventType,
                limit:        params.limit === undefined ? undefined : String(params.limit),
                offset:       params.offset === undefined ? undefined : String(params.offset),
                resourceType: params.resourceType,
                tenantId:     params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events`, undefined, {query})
            return await resp.json() as ListEventsResponse
        }
    }
}

/**
 * Evaluations service: runs evaluation datasets through
 * search -> LLM response -> LLM judge + statistical metrics.
 * 
 * Stores all runs with full config snapshots for tracking changes over time.
 * Own PostgreSQL database, independent of the main app.
 */
export namespace evaluations {
    export interface Citation {
        title: string
        url: string | null
        snippet: string
    }

    export interface CompareRunsRequest {
        runIdA: string
        runIdB: string
    }

    export interface CreateRunRequest {
        datasetId: string
        name?: string
        retrievalConfig?: {
            topK?: number
            retriever?: RetrieverType
        }
        responderConfig?: {
            model?: string
            temperature?: number
            maxTokens?: number
            systemPromptVersion?: string
        }
        judgeConfig?: {
            model?: string
            temperature?: number
            dimensions?: string[]
            weights?: { [key: string]: number }
        }
        entryFilter?: EntryFilter
    }

    export interface EntryFilter {
        categories?: string[]
        limit?: number
        offset?: number
    }

    export interface EvalDataset {
        id: string
        name: string
        source: "community_forum" | "test_suite" | "live"
        hasGroundTruth: boolean
        entryCount: number
        metadata: { [key: string]: any }
        createdAt: string
    }

    export interface EvalEntry {
        id: string
        datasetId: string
        question: string
        groundTruthAnswer: string | null
        category: string | null
        metadata: { [key: string]: any }
        createdAt: string
    }

    export interface EvalResult {
        id: string
        runId: string
        entryId: string
        retrievedDocuments: RetrievedDocument[] | null
        response: string | null
        citations: Citation[] | null
        judgeScore: number | null
        judgeBreakdown: JudgeBreakdown | null
        judgeRationale: string | null
        statisticalMetrics: StatisticalMetrics | null
        retrievalMs: number | null
        responseMs: number | null
        judgeMs: number | null
        createdAt: string
    }

    /**
     * Result with entry data joined (for the detail view)
     */
    export interface EvalResultDetail {
        question: string
        groundTruthAnswer: string | null
        category: string | null
        id: string
        runId: string
        entryId: string
        retrievedDocuments: RetrievedDocument[] | null
        response: string | null
        citations: Citation[] | null
        judgeScore: number | null
        judgeBreakdown: JudgeBreakdown | null
        judgeRationale: string | null
        statisticalMetrics: StatisticalMetrics | null
        retrievalMs: number | null
        responseMs: number | null
        judgeMs: number | null
        createdAt: string
    }

    export interface EvalRun {
        id: string
        datasetId: string
        name: string | null
        description: string | null
        status: RunStatus
        retrievalConfig: RetrievalConfig
        responderConfig: ResponderConfig
        judgeConfig: JudgeConfig
        gitCommit: string | null
        /**
         * The KB snapshot taken at run start, opaque on the API (D163): `zac_memory` label counts on runs
         * before round B, `{ providers: [{ provider, documents, chunks }] }` since (D162).
         */
        kbStats: { [key: string]: any } | null

        modelIds: ModelIds | null
        entryFilter: EntryFilter | null
        entryCount: number
        summary: RunSummary | null
        startedAt: string | null
        completedAt: string | null
        createdAt: string
    }

    export interface JudgeBreakdown {
        grounding: number
        conflicts: number
        helpfulness: number
        actionability: number
        specificity: number
    }

    export interface JudgeConfig {
        model: string
        temperature: number
        dimensions: string[]
        weights: { [key: string]: number }
    }

    export interface ModelIds {
        embedding: string
        responder: string
        judge: string
    }

    export interface ResponderConfig {
        model: string
        temperature: number
        maxTokens: number
        systemPromptVersion: string
    }

    /**
     * The knobs the documents retriever reads. Older rows' extra JSON fields (threshold, nodeLabels,
     * topKRetriever, reranker) stay in storage and pass through untyped (D164).
     */
    export interface RetrievalConfig {
        topK?: number
        retriever?: RetrieverType
    }

    export interface RetrievedDocument {
        nodeLabel: string
        nodeId: string
        title: string
        snippet: string
        url: string | null
        similarity: number
        properties: { [key: string]: any }
    }

    /**
     * The one retriever left: the brain's navigation-KB contract `memory.searchDocuments` (D120). Run rows
     * from before round B keep their `semantic` / `bm25` / `hybrid` strings in storage (D150).
     */
    export type RetrieverType = "documents"

    export interface RunComparison {
        runA: EvalRun
        runB: EvalRun
        deltaJudgeScore: number
        deltaBreakdown: JudgeBreakdown
        deltaStatisticalMetrics: StatisticalMetrics
    }

    export type RunStatus = "pending" | "running" | "completed" | "failed" | "cancelled"

    export interface RunSummary {
        avgJudgeScore: number
        avgBreakdown: JudgeBreakdown
        avgStatisticalMetrics: StatisticalMetrics
        entryCount: number
        completedCount: number
        errorCount: number
        totalDurationMs: number
    }

    export interface StatisticalMetrics {
        "rouge_l"?: number
        "rouge_1"?: number
        "answer_similarity"?: number
    }

    export interface UpdateRunRequest {
        description?: string
        name?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.compareRuns = this.compareRuns.bind(this)
            this.createRun = this.createRun.bind(this)
            this.getDatasetEntries = this.getDatasetEntries.bind(this)
            this.getRun = this.getRun.bind(this)
            this.getRunResults = this.getRunResults.bind(this)
            this.getRunResultsDetail = this.getRunResultsDetail.bind(this)
            this.importDataset = this.importDataset.bind(this)
            this.listDatasets = this.listDatasets.bind(this)
            this.listRuns = this.listRuns.bind(this)
            this.updateRun = this.updateRun.bind(this)
        }

        public async compareRuns(params: CompareRunsRequest): Promise<RunComparison> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                runIdA: params.runIdA,
                runIdB: params.runIdB,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/compare`, undefined, {query})
            return await resp.json() as RunComparison
        }

        public async createRun(params: CreateRunRequest): Promise<{
    runId: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/evaluations/runs`, JSON.stringify(params))
            return await resp.json() as {
    runId: string
}
        }

        public async getDatasetEntries(datasetId: string, params: {
    limit?: number
    offset?: number
    category?: string
}): Promise<{
    entries: EvalEntry[]
    total: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/datasets/${encodeURIComponent(datasetId)}/entries`, undefined, {query})
            return await resp.json() as {
    entries: EvalEntry[]
    total: number
}
        }

        public async getRun(runId: string): Promise<EvalRun> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/runs/${encodeURIComponent(runId)}`)
            return await resp.json() as EvalRun
        }

        public async getRunResults(runId: string, params: {
    limit?: number
    offset?: number
}): Promise<{
    results: EvalResult[]
    total: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/runs/${encodeURIComponent(runId)}/results`, undefined, {query})
            return await resp.json() as {
    results: EvalResult[]
    total: number
}
        }

        /**
         * Results with entry data joined — for the full-page run detail view
         */
        public async getRunResultsDetail(runId: string, params: {
    limit?: number
    offset?: number
    sortBy?: string
    sortOrder?: string
    category?: string
    minScore?: number
    maxScore?: number
}): Promise<{
    results: EvalResultDetail[]
    total: number
    categories: string[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category:  params.category,
                limit:     params.limit === undefined ? undefined : String(params.limit),
                maxScore:  params.maxScore === undefined ? undefined : String(params.maxScore),
                minScore:  params.minScore === undefined ? undefined : String(params.minScore),
                offset:    params.offset === undefined ? undefined : String(params.offset),
                sortBy:    params.sortBy,
                sortOrder: params.sortOrder,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/runs/${encodeURIComponent(runId)}/results-detail`, undefined, {query})
            return await resp.json() as {
    results: EvalResultDetail[]
    total: number
    categories: string[]
}
        }

        public async importDataset(): Promise<{
    datasetId: string
    entryCount: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/evaluations/datasets/import`)
            return await resp.json() as {
    datasetId: string
    entryCount: number
}
        }

        public async listDatasets(): Promise<{
    datasets: EvalDataset[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/datasets`)
            return await resp.json() as {
    datasets: EvalDataset[]
}
        }

        public async listRuns(params: {
    datasetId?: string
    status?: string
    limit?: number
}): Promise<{
    runs: EvalRun[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                datasetId: params.datasetId,
                limit:     params.limit === undefined ? undefined : String(params.limit),
                status:    params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/evaluations/runs`, undefined, {query})
            return await resp.json() as {
    runs: EvalRun[]
}
        }

        public async updateRun(runId: string, params: UpdateRunRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/evaluations/runs/${encodeURIComponent(runId)}`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }
    }
}

export namespace events {
    export interface ActivityMetric {
        category: string
        metric: string
        count: number
        errorCount: number
        avgLatencyMs: number
    }

    export interface ActivityRequest {
        tenantId?: string
        userId?: string
        category?: string
        days?: number
    }

    export interface ActivityResponse {
        metrics: ActivityMetric[]
        period: {
            days: number
            from: string
            to: string
        }
    }

    export interface AuditLogEntry {
        id: string
        eventType: string
        adminUserId: string
        resourceType: string
        resourceId: string | null
        tenantId: string
        beforeData: { [key: string]: any } | null
        afterData: { [key: string]: any } | null
        metadata: { [key: string]: any }
        createdAt: string
    }

    export interface BackfillRequest {
        days?: number
    }

    export interface BackfillResponse {
        llmRows: number
        activityRows: number
        eventsProcessed: number
        duration: string
    }

    export interface Consumer {
        id: string
        requestCount: number
        totalTokens: number
        costUsd: number
        avgCostPerRequest: number
        topModel: string
    }

    export interface EventEntry {
        id: string
        type: string
        tenantId: string
        userId?: string
        conversationId?: string
        requestId?: string
        data: { [key: string]: any }
        cost?: {
            amount: number
            unit: string
            quantity: number
        }
        createdAt: string
    }

    export interface GetTurnResponse {
        requestId: string
        conversationId: string | null
        tenantId: string
        userId: string | null
        userEmail: string | null
        events: TraceEvent[]
    }

    export interface ListAuditLogRequest {
        adminUserId?: string
        eventType?: string
        resourceType?: string
        resourceId?: string
        dateFrom?: string
        dateTo?: string
        limit?: number
        offset?: number
    }

    export interface ListAuditLogResponse {
        entries: AuditLogEntry[]
        total: number
        hasMore: boolean
    }

    export interface ListEventsRequest {
        type?: string
        tenantId?: string
        conversationId?: string
        limit?: number
        offset?: number
    }

    export interface ListEventsResponse {
        events: EventEntry[]
        total: number
        hasMore: boolean
    }

    export interface ListTurnsRequest {
        tenantId?: string
        outcome?: string
        limit?: number
        offset?: number
    }

    export interface ListTurnsResponse {
        turns: TurnSummary[]
        total: number
    }

    export interface StreamEventMessage {
        type: "connected" | "event"
        event?: EventEntry
    }

    export interface StreamEventsRequest {
        conversationId?: string
        tenantId?: string
        filter?: string
    }

    export interface TopConsumersRequest {
        days?: number
        limit?: number
        dimension?: string
    }

    export interface TopConsumersResponse {
        consumers: Consumer[]
        totalCost: number
    }

    export interface TraceEvent {
        id: string
        type: string
        data: { [key: string]: any }
        costUsd: number | null
        createdAt: string
    }

    export interface TurnSummary {
        requestId: string
        conversationId: string | null
        tenantId: string
        userId: string | null
        userEmail: string | null
        message: string
        startedAt: string
        /**
         * Null while the turn is still running (or if its closing event was lost).
         */
        outcome: string | null

        durationMs: number | null
        intent: string | null
        brainSkill: string | null
        toolCalls: number
        failedToolCalls: number
        costUsd: number
    }

    export interface UsageEntry {
        date?: string
        model?: string
        provider?: string
        tenantId?: string
        userId?: string
        requestCount: number
        inputTokens: number
        outputTokens: number
        totalTokens: number
        costUsd: number
        totalLatencyMs: number
        errorCount: number
    }

    export interface UsageRequest {
        tenantId?: string
        userId?: string
        model?: string
        days?: number
        groupBy?: string
    }

    export interface UsageResponse {
        entries: UsageEntry[]
        totals: {
            requestCount: number
            totalTokens: number
            costUsd: number
            avgCostPerRequest: number
            errorRate: number
        }
        period: {
            days: number
            from: string
            to: string
        }
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.backfillUsage = this.backfillUsage.bind(this)
            this.getActivity = this.getActivity.bind(this)
            this.getEventsSummary = this.getEventsSummary.bind(this)
            this.getTopConsumers = this.getTopConsumers.bind(this)
            this.getTurn = this.getTurn.bind(this)
            this.getUsage = this.getUsage.bind(this)
            this.listAuditLog = this.listAuditLog.bind(this)
            this.listEvents = this.listEvents.bind(this)
            this.listTurns = this.listTurns.bind(this)
            this.streamEvents = this.streamEvents.bind(this)
        }

        public async backfillUsage(params: BackfillRequest): Promise<BackfillResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/events/usage/backfill`, JSON.stringify(params))
            return await resp.json() as BackfillResponse
        }

        public async getActivity(params: ActivityRequest): Promise<ActivityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                days:     params.days === undefined ? undefined : String(params.days),
                tenantId: params.tenantId,
                userId:   params.userId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/usage/activity`, undefined, {query})
            return await resp.json() as ActivityResponse
        }

        /**
         * Get summary of events by type
         */
        public async getEventsSummary(params: {
    tenantId?: string
}): Promise<{
    byType: {
        type: string
        count: number
    }[]
    total: number
    last24h: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/summary`, undefined, {query})
            return await resp.json() as {
    byType: {
        type: string
        count: number
    }[]
    total: number
    last24h: number
}
        }

        public async getTopConsumers(params: TopConsumersRequest): Promise<TopConsumersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:      params.days === undefined ? undefined : String(params.days),
                dimension: params.dimension,
                limit:     params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/usage/top-consumers`, undefined, {query})
            return await resp.json() as TopConsumersResponse
        }

        /**
         * Every event of one chat turn, in order.
         */
        public async getTurn(requestId: string): Promise<GetTurnResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/turns/${encodeURIComponent(requestId)}`)
            return await resp.json() as GetTurnResponse
        }

        public async getUsage(params: UsageRequest): Promise<UsageResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:     params.days === undefined ? undefined : String(params.days),
                groupBy:  params.groupBy,
                model:    params.model,
                tenantId: params.tenantId,
                userId:   params.userId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/usage`, undefined, {query})
            return await resp.json() as UsageResponse
        }

        public async listAuditLog(params: ListAuditLogRequest): Promise<ListAuditLogResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                adminUserId:  params.adminUserId,
                dateFrom:     params.dateFrom,
                dateTo:       params.dateTo,
                eventType:    params.eventType,
                limit:        params.limit === undefined ? undefined : String(params.limit),
                offset:       params.offset === undefined ? undefined : String(params.offset),
                resourceId:   params.resourceId,
                resourceType: params.resourceType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/audit`, undefined, {query})
            return await resp.json() as ListAuditLogResponse
        }

        /**
         * List events with optional filters
         */
        public async listEvents(params: ListEventsRequest): Promise<ListEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                limit:          params.limit === undefined ? undefined : String(params.limit),
                offset:         params.offset === undefined ? undefined : String(params.offset),
                tenantId:       params.tenantId,
                type:           params.type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus`, undefined, {query})
            return await resp.json() as ListEventsResponse
        }

        /**
         * List chat turns, newest first.
         */
        public async listTurns(params: ListTurnsRequest): Promise<ListTurnsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
                outcome:  params.outcome,
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/turns`, undefined, {query})
            return await resp.json() as ListTurnsResponse
        }

        /**
         * Stream events via WebSocket with polling
         */
        public async streamEvents(params: StreamEventsRequest): Promise<StreamIn<StreamEventMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                filter:         params.filter,
                tenantId:       params.tenantId,
            })

            return await this.baseClient.createStreamIn(`/events/bus/stream`, {query})
        }
    }
}

/**
 * Execution service walks a B2-validated recipe step-by-step against a
 * live Playwright Page. Zero LLM calls on the hot path — selector
 * resolution is deterministic (role+name → data-testid → xpath), and
 * each step's outgoing edge comes from the zoom-map graph. Sibling
 * service to `recipe` (storage) and `zoom-map` (graph topology).
 * NOTE — distinct from the sibling `backend/executor/` service. That
 * one runs Stagehand-based execution plans against Zoom APIs (see
 * `backend/executor/api.ts` + `cascade-discovery`). This `execution/`
 * service is the non-inference Playwright walker for B2-validated
 * recipes — no Stagehand, no LLM calls in the hot path.
 */
export namespace execution {
    export interface TeleportRequest {
        /**
         * The settings-map entry to go to: a placement, a section or a page (the card's `teleport:<id>`).
         */
        entryId: string

        /**
         * The conversation the card was in; the outcome's line is stored there.
         */
        conversationId?: string

        /**
         * Or the plan whose human step names the entry (with `stepKey`); the line goes to the plan's conversation.
         */
        planId?: string

        stepKey?: string
    }

    export interface TeleportResponse {
        outcome: teleport.OutcomeKind
        /**
         * The user's one line, also stored in the conversation.
         */
        line: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.teleport = this.teleport.bind(this)
        }

        public async teleport(params: TeleportRequest): Promise<TeleportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/execution/teleport`, JSON.stringify(params))
            return await resp.json() as TeleportResponse
        }
    }
}

/**
 * Experiments service: dev/research tools for testing routing, planning,
 * complexity detection, KB quality, and benchmarking.
 */
export namespace experiments {
    export interface ApproachResult {
        matched: boolean
        endpoint?: {
            method: string
            path: string
        }
        latencyMs: number
        tokensUsed?: number
    }

    export interface BenchmarkResponse {
        totalQueries: number
        results: QueryResult[]
        summary: {
            embeddings: {
                accuracy: number
                avgLatencyMs: number
            }
            "llm_routing": {
                accuracy: number
                avgLatencyMs: number
            }
            structured: {
                accuracy: number
                avgLatencyMs: number
            }
        }
        winner: string
    }

    export interface ClarificationAnalysis {
        queryId: string
        query: string
        expectedEndpoint?: string
        /**
         * Embedding results
         */
        top1: TopKResult

        top2: TopKResult
        top3: TopKResult
        /**
         * Analysis
         */
        top1Correct: boolean

        ambiguityDetected: boolean
        ambiguityReason?: "close_scores" | "low_confidence"
        correctInTopK: boolean
        wouldClarify: boolean
        clarificationWouldHelp: boolean
        /**
         * Generated clarification (if ambiguous)
         */
        clarifyingQuestion?: string

        clarifyingOptions?: string[]
    }

    export interface ClarificationExperimentResponse {
        totalQueries: number
        results: ClarificationAnalysis[]
        summary: {
            baselineAccuracy: number
            ambiguityRate: number
            correctInTop3Rate: number
            theoreticalAccuracy: number
            clarificationWouldHelp: number
        }
    }

    export interface DetectorResponse {
        totalTests: number
        results: DetectorResult[]
        summary: {
            rulesAccuracy: number
            llmAccuracy: number
            hybridAccuracy: number
            rulesAvgLatency: number
            llmAvgLatency: number
            hybridAvgLatency: number
            hybridLLMCallRate: number
        }
    }

    export interface DetectorResult {
        id: string
        query: string
        expected: "simple" | "complex"
        rules: {
            prediction: "simple" | "complex"
            confidence: number
            correct: boolean
        }
        llm: {
            prediction: "simple" | "complex"
            confidence: number
            correct: boolean
            latencyMs: number
        }
        hybrid: {
            prediction: "simple" | "complex"
            confidence: number
            method: string
            correct: boolean
            latencyMs: number
        }
    }

    export interface EndpointDef {
        method: string
        path: string
        description: string
        exampleQueries?: string[]
    }

    export interface ExecutionStep {
        endpoint: string
        purpose: string
        storeAs: string
    }

    export interface ExperimentRequest {
        category?: string
        id?: string
    }

    export interface IntentExperimentResponse {
        totalTests: number
        results: TestResult[]
        summary: {
            intentDrivenAvgF1: number
            nativeToolsAvgF1: number
            planningModeAvgF1: number
            kbFirstAvgF1: number
            intentDrivenAvgLatency: number
            nativeToolsAvgLatency: number
            planningModeAvgLatency: number
            kbFirstAvgLatency: number
            intentDrivenWins: number
            nativeToolsWins: number
            planningModeWins: number
            kbFirstWins: number
            ties: number
        }
    }

    export interface MultiStepExperimentResponse {
        totalQueries: number
        results: PlanResult[]
        summary: {
            multiStepDetectionAccuracy: number
            endpointSelectionAccuracy: number
            operationAccuracy: number
            overallAccuracy: number
            avgPlanLatencyMs: number
        }
        samplePlans: {
            query: string
            plan: MultiStepPlan
        }[]
    }

    export interface MultiStepPlan {
        isMultiStep: boolean
        reasoning: string
        steps: ExecutionStep[]
        finalStep: {
            operation: "return" | "compare" | "aggregate" | "filter" | "count"
            logic: string
        }
    }

    export interface PlanResult {
        testId: string
        query: string
        expected: {
            multiStep: boolean
            endpoints: string[]
            operation: string
        }
        actual: {
            plan: MultiStepPlan
            latencyMs: number
        }
        evaluation: {
            multiStepCorrect: boolean
            endpointsCorrect: boolean
            operationCorrect: boolean
            overallCorrect: boolean
        }
    }

    export interface PlanStep {
        id: string
        operation: string
        endpoint: string
        method: "POST" | "PUT" | "PATCH" | "DELETE"
        description: string
        dependsOn: string[]
        payload: { [key: string]: any }
        outputVar?: string
    }

    export interface PlannedStep {
        tool: string
        params: { [key: string]: any }
        reason: string
    }

    export interface PlannerExperimentPlan {
        name: string
        description: string
        steps: PlanStep[]
        estimatedApiCalls: number
    }

    export interface PlannerResponse {
        plan: PlannerExperimentPlan
        validation: ValidationResult
        generationTimeMs: number
        kbContextUsed: boolean
    }

    export type Product = "contact_center" | "phone" | "virtual_agent" | "meetings" | "team_chat" | "quality_management" | "workforce_management"

    export interface ProductRoutingExperimentResponse {
        totalTests: number
        results: TestResult[]
        summary: {
            queryTypeAccuracy: number
            productFilterAccuracy: number
            disambiguationAccuracy: number
            overallAccuracy: number
            byCategory: { [key: string]: {
                total: number
                correct: number
                accuracy: number
            } }
        }
    }

    export interface QueryResult {
        id: string
        query: string
        expectedEndpoint?: string
        approaches: {
            embeddings: ApproachResult
            "llm_routing": ApproachResult
            structured: ApproachResult
        }
    }

    export interface TestResult {
        id: string
        query: string
        expectedTools: string[]
        intentDriven: {
            tools: string[]
            intent: string
            f1: number
            latencyMs: number
            tokens: number
        }
        nativeTools: {
            tools: string[]
            f1: number
            latencyMs: number
            tokens: number
        }
        planningMode: {
            tools: string[]
            plan: PlannedStep[]
            f1: number
            latencyMs: number
            tokens: number
        }
        kbFirst: {
            tools: string[]
            kbUsedAlone: boolean
            f1: number
            latencyMs: number
            tokens: number
        }
        winner: string
    }

    export interface TestResult {
        id: string
        query: string
        category: string
        description: string
        expected: {
            queryType: "knowledge" | "config"
            products: Product[]
            needsDisambiguation: boolean
        }
        actual: {
            queryType: "knowledge" | "config"
            products: Product[]
            needsDisambiguation: boolean
            disambiguationQuestion?: string
        }
        correct: {
            queryType: boolean
            products: boolean
            disambiguation: boolean
            overall: boolean
        }
    }

    export interface TopKResult {
        endpoint: EndpointDef
        similarity: number
    }

    export interface ValidationResult {
        valid: boolean
        errors: string[]
        warnings: string[]
        coverage: {
            skills: boolean
            queues: boolean
            flows: boolean
            addressBook: boolean
            virtualAgent: boolean
            knowledgeBase: boolean
            widgets: boolean
            expertAssist: boolean
            qualityManagement: boolean
            workforceManagement: boolean
            campaigns: boolean
        }
        dependencyOrder: boolean
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.planQuery = this.planQuery.bind(this)
            this.runClarificationExperiment = this.runClarificationExperiment.bind(this)
            this.runComplexityDetector = this.runComplexityDetector.bind(this)
            this.runExperimentBenchmark = this.runExperimentBenchmark.bind(this)
            this.runIntentExperiment = this.runIntentExperiment.bind(this)
            this.runMultiStepExperiment = this.runMultiStepExperiment.bind(this)
            this.runPlanner = this.runPlanner.bind(this)
            this.runProductRouting = this.runProductRouting.bind(this)
            this.testIntent = this.testIntent.bind(this)
        }

        public async planQuery(params: {
    query: string
}): Promise<{
    query: string
    plan: MultiStepPlan
    latencyMs: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/experiments/plan`, JSON.stringify(params))
            return await resp.json() as {
    query: string
    plan: MultiStepPlan
    latencyMs: number
}
        }

        public async runClarificationExperiment(): Promise<ClarificationExperimentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/clarification`)
            return await resp.json() as ClarificationExperimentResponse
        }

        public async runComplexityDetector(): Promise<DetectorResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/complexity-detector`)
            return await resp.json() as DetectorResponse
        }

        public async runExperimentBenchmark(): Promise<BenchmarkResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/benchmark`)
            return await resp.json() as BenchmarkResponse
        }

        public async runIntentExperiment(params: ExperimentRequest): Promise<IntentExperimentResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                id:       params.id,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/intent-vs-native`, undefined, {query})
            return await resp.json() as IntentExperimentResponse
        }

        public async runMultiStepExperiment(): Promise<MultiStepExperimentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/multi-step`)
            return await resp.json() as MultiStepExperimentResponse
        }

        public async runPlanner(): Promise<PlannerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/planner`)
            return await resp.json() as PlannerResponse
        }

        public async runProductRouting(params: {
    category?: string
}): Promise<ProductRoutingExperimentResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/experiments/product-routing`, undefined, {query})
            return await resp.json() as ProductRoutingExperimentResponse
        }

        public async testIntent(params: {
    intent: string
}): Promise<{
    intent: string
    embeddings: ApproachResult
    "llm_routing": ApproachResult
    structured: ApproachResult
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/experiments/test`, JSON.stringify(params))
            return await resp.json() as {
    intent: string
    embeddings: ApproachResult
    "llm_routing": ApproachResult
    structured: ApproachResult
}
        }
    }
}

/**
 * Graph config service manages tenant-specific configuration graphs in FalkorDB
 */
export namespace graph_config {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.addRelationship = this.addRelationship.bind(this)
            this.deleteResource = this.deleteResource.bind(this)
            this.deleteTenant = this.deleteTenant.bind(this)
            this.detectCycles = this.detectCycles.bind(this)
            this.findPath = this.findPath.bind(this)
            this.getDependencies = this.getDependencies.bind(this)
            this.getDependents = this.getDependents.bind(this)
            this.getExecutionOrder = this.getExecutionOrder.bind(this)
            this.initializeTenant = this.initializeTenant.bind(this)
            this.listResources = this.listResources.bind(this)
            this.listTenants = this.listTenants.bind(this)
            this.upsertResource = this.upsertResource.bind(this)
        }

        /**
         * Add a relationship between resources
         */
        public async addRelationship(tenantId: string, params: {
    fromType: string
    fromId: string
    toType: string
    toId: string
    relationship: "DEPENDS_ON" | "ROUTES_TO" | "CONTAINS" | "REFERENCES"
    properties?: { [key: string]: any }
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/relationships`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Delete a resource node and its relationships
         */
        public async deleteResource(tenantId: string, _type: string, resourceId: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources/${encodeURIComponent(_type)}/${encodeURIComponent(resourceId)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Delete a tenant's graph
         */
        public async deleteTenant(tenantId: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/graph/config/tenants/${encodeURIComponent(tenantId)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Detect circular dependencies
         */
        public async detectCycles(tenantId: string): Promise<{
    cycles: config.ResourceNode[][]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/cycles`)
            return await resp.json() as {
    cycles: config.ResourceNode[][]
}
        }

        /**
         * Find the dependency path between two resources
         */
        public async findPath(tenantId: string, params: {
    fromType: string
    fromId: string
    toType: string
    toId: string
}): Promise<{
    path: config.DependencyPath | null
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                fromId:   params.fromId,
                fromType: params.fromType,
                toId:     params.toId,
                toType:   params.toType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/path`, undefined, {query})
            return await resp.json() as {
    path: config.DependencyPath | null
}
        }

        /**
         * Get all dependencies for a resource (what it depends on)
         */
        public async getDependencies(tenantId: string, _type: string, resourceId: string): Promise<{
    dependencies: config.ResourceNode[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources/${encodeURIComponent(_type)}/${encodeURIComponent(resourceId)}/dependencies`)
            return await resp.json() as {
    dependencies: config.ResourceNode[]
}
        }

        /**
         * Get all dependents of a resource (what depends on it)
         */
        public async getDependents(tenantId: string, _type: string, resourceId: string): Promise<{
    dependents: config.ResourceNode[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources/${encodeURIComponent(_type)}/${encodeURIComponent(resourceId)}/dependents`)
            return await resp.json() as {
    dependents: config.ResourceNode[]
}
        }

        /**
         * Get topological order for execution (respecting dependencies)
         */
        public async getExecutionOrder(tenantId: string, params: {
    resourceIds: {
        type: string
        resourceId: string
    }[]
}): Promise<{
    order: {
        type: string
        resourceId: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/execution-order`, JSON.stringify(params))
            return await resp.json() as {
    order: {
        type: string
        resourceId: string
    }[]
}
        }

        /**
         * Initialize a tenant's graph database
         */
        public async initializeTenant(tenantId: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/initialize`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Get all resources for a tenant
         */
        public async listResources(tenantId: string, params: {
    type?: string
}): Promise<{
    resources: config.ResourceNode[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                type: params.type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources`, undefined, {query})
            return await resp.json() as {
    resources: config.ResourceNode[]
}
        }

        /**
         * List all tenants
         */
        public async listTenants(): Promise<{
    tenants: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants`)
            return await resp.json() as {
    tenants: string[]
}
        }

        /**
         * Add or update a resource node for a tenant
         */
        public async upsertResource(tenantId: string, params: {
    type: string
    resourceId: string
    name: string
    properties: { [key: string]: any }
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }
    }
}

export namespace guides {
    export interface CreateTopicRequest {
        question: string
        product: string
        category: string
        slug: string
        difficulty: "beginner" | "intermediate" | "advanced"
        tags?: string[]
        source?: string
        sourceDetail?: string
    }

    export interface ExportTopicsRequest {
        category?: string
        status?: string
    }

    export interface ExportTopicsResponse {
        topics: {
            slug: string
            question: string
            product: string
            category: string
            difficulty: string
            tags: string[]
        }[]
    }

    export interface GetTopicResponse {
        topic: GuideTopic
        faq: {
            question: string
            answer: string
        }[]
    }

    export interface GuideTopic {
        id: string
        slug: string
        question: string
        product: string
        category: string
        difficulty: string
        tags: string[]
        status: string
        source: string
        sourceDetail?: string
        title?: string
        description?: string
        estimatedTime?: string
        wordCount?: number
        kbResultsCount: number
        generatedAt?: string
        publishedAt?: string
        generationError?: string
        createdAt: string
        updatedAt: string
    }

    export interface ListTopicsRequest {
        category?: string
        status?: string
        source?: string
        limit?: number
        offset?: number
    }

    export interface ListTopicsResponse {
        topics: GuideTopic[]
        total: number
    }

    export interface TopicStatsResponse {
        total: number
        byStatus: { [key: string]: number }
        byCategory: { [key: string]: number }
        bySource: { [key: string]: number }
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.createGuideTopic = this.createGuideTopic.bind(this)
            this.exportTopicsForGeneration = this.exportTopicsForGeneration.bind(this)
            this.getGuideTopic = this.getGuideTopic.bind(this)
            this.getGuideTopicStats = this.getGuideTopicStats.bind(this)
            this.listGuideTopics = this.listGuideTopics.bind(this)
        }

        public async createGuideTopic(params: CreateTopicRequest): Promise<GuideTopic> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/guides/topics`, JSON.stringify(params))
            return await resp.json() as GuideTopic
        }

        /**
         * Internal endpoint for the guide generator script to pull topics.
         */
        public async exportTopicsForGeneration(params: ExportTopicsRequest): Promise<ExportTopicsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                status:   params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/guides/topics/export`, undefined, {query})
            return await resp.json() as ExportTopicsResponse
        }

        public async getGuideTopic(slug: string): Promise<GetTopicResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/guides/topics/${encodeURIComponent(slug)}`)
            return await resp.json() as GetTopicResponse
        }

        public async getGuideTopicStats(): Promise<TopicStatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/guides/topics/stats`)
            return await resp.json() as TopicStatsResponse
        }

        public async listGuideTopics(params: ListTopicsRequest): Promise<ListTopicsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
                source:   params.source,
                status:   params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/guides/topics`, undefined, {query})
            return await resp.json() as ListTopicsResponse
        }
    }
}

export namespace mcp_zoom {
    export interface ActivityEntry {
        id: string
        eventType: string
        /**
         * Human label, e.g. "Disabled 'Join Before Host'".
         */
        label: string

        /**
         * How it was applied: 'api' | 'harness' (entries from before plans) | undefined; a plan's channels are in `details`.
         */
        path?: string

        outcome?: string
        /**
         * True when this entry is a completed plan the plans service can undo (`POST /plans/:id/revert`, then approve and run).
         */
        revertable: boolean

        /**
         * JSON-encoded extra details (changed fields for drift, scopes for access).
         */
        details?: string

        createdAt: string
    }

    export interface ActivityResponse {
        entries: ActivityEntry[]
        total: number
    }

    export interface LiveStreamHandshake {
        accountId?: string
        token?: string
        /**
         * Polling interval in seconds (default 30, min 10)
         */
        interval?: number
    }

    export interface LiveStreamMessage {
        type: string
        totalLive?: number
        meetings?: string
        timestamp?: string
        message?: string
    }

    export interface OverviewRequest {
        accountId?: string
    }

    export interface OverviewStreamHandshake {
        accountId?: string
        token?: string
        /**
         * Why this generation ran — recorded in the activity feed:
         * 'initial' (first report) | 'manual' (Refresh button) | 'auto' (post-fix).
         */
        trigger?: string
    }

    /**
     * Single flat message interface for the overview stream.
     * Encore requires a named interface (not a union type) for streaming generics.
     * 
     * Message types:
     * - "step"    → name, label, stepStatus, completed, total
     * - "section" → name, data (JSON string)
     * - "done"    → fetchedAt, scope
     * - "error"   → message
     */
    export interface OverviewStreamMessage {
        type: string
        /**
         * Step fields
         */
        name?: string

        label?: string
        stepStatus?: string
        completed?: number
        total?: number
        /**
         * Section fields
         */
        data?: string

        /**
         * Done fields
         */
        fetchedAt?: string

        scope?: string
        /**
         * Error fields
         */
        message?: string
    }

    export interface QosParticipant {
        name: string
        email?: string
        device?: string
        audio: lib.QosMetrics
        video: lib.QosMetrics
        screenShare?: lib.QosMetrics
    }

    export interface QosRequest {
        accountId?: string
    }

    export interface QosResponse {
        meetingUuid: string
        participants: QosParticipant[]
        error?: string
    }

    export interface ReportChatHandshake {
        token?: string
        accountId?: string
        /**
         * JSON-encoded overview data
         */
        accountData?: string

        /**
         * JSON-encoded chat history
         */
        history?: string

        /**
         * User's message
         */
        message?: string
    }

    /**
     * Single flat message interface for the report chat stream.
     * Encore requires a named interface (not a union type) for streaming generics.
     */
    export interface ReportChatMessage {
        type: string
        content?: string
        message?: string
        /**
         * A request's card (plans/document/chat-card.ts): the app follows the document; its option opens the request's page.
         */
        interactive?: {
            type: string
            prompt?: string
            options?: {
                id: string
                label: string
                description?: string
                value: string
                icon?: string
                disabled?: boolean
                hint?: string
                highlight?: boolean
            }[]
            document?: chat.DocumentCardSummary
        }
    }

    export interface StoredReportResponse {
        found: boolean
        /**
         * JSON-encoded ZoomOverviewData (Encore can't type the full union tree).
         */
        data?: string

        generatedAt?: string
        /**
         * True when a regen condition fired since generation (FE silently refreshes).
         */
        stale?: boolean

        accountId?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getAccountActivity = this.getAccountActivity.bind(this)
            this.getMeetingQos = this.getMeetingQos.bind(this)
            this.getOverview = this.getOverview.bind(this)
            this.getStoredReportEndpoint = this.getStoredReportEndpoint.bind(this)
            this.mcpSSEEndpoint = this.mcpSSEEndpoint.bind(this)
            this.reportChat = this.reportChat.bind(this)
            this.streamLiveMeetings = this.streamLiveMeetings.bind(this)
            this.streamOverview = this.streamOverview.bind(this)
        }

        public async getAccountActivity(params: {
    limit?: number
    offset?: number
}): Promise<ActivityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/report/activity`, undefined, {query})
            return await resp.json() as ActivityResponse
        }

        public async getMeetingQos(meetingId: string, params: QosRequest): Promise<QosResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/meetings/${encodeURIComponent(meetingId)}/qos`, undefined, {query})
            return await resp.json() as QosResponse
        }

        public async getOverview(params: OverviewRequest): Promise<lib.ZoomOverviewData> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/overview`, undefined, {query})
            return await resp.json() as lib.ZoomOverviewData
        }

        public async getStoredReportEndpoint(): Promise<StoredReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/report/stored`)
            return await resp.json() as StoredReportResponse
        }

        /**
         * MCP SSE endpoint - handles GET (SSE connection) and POST (JSON-RPC messages).
         * Requires a bearer token; the tenant always comes from the session, never the request.
         * Optional ?accountId= selects one of that tenant's connected Zoom accounts.
         */
        public async mcpSSEEndpoint(method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE" | "HEAD" | "OPTIONS" | "TRACE", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/mcp/zoom/sse`, body, options)
        }

        public async reportChat(params: ReportChatHandshake): Promise<StreamIn<ReportChatMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountData: params.accountData,
                accountId:   params.accountId,
                history:     params.history,
                message:     params.message,
                token:       params.token,
            })

            return await this.baseClient.createStreamIn(`/report/chat`, {query})
        }

        public async streamLiveMeetings(params: LiveStreamHandshake): Promise<StreamIn<LiveStreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
                interval:  params.interval === undefined ? undefined : String(params.interval),
                token:     params.token,
            })

            return await this.baseClient.createStreamIn(`/zoom/meetings/live/stream`, {query})
        }

        public async streamOverview(params: OverviewStreamHandshake): Promise<StreamIn<OverviewStreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
                token:     params.token,
                trigger:   params.trigger,
            })

            return await this.baseClient.createStreamIn(`/zoom/overview/stream`, {query})
        }
    }
}

/**
 * The navigation KB: engine, knowledge stratum, the documents contract (DESIGN_INTEGRATION.md D161).
 * 
 * - navigation/ — the 206 navigation engine and knowledge stratum: per-provider graphs
 * (zac_nav_<provider>_docs), the seed manifests, and the `/navigation/*` endpoints behind the
 * admin views; `POST /memory/documents/search` (`searchDocuments`) is the brain's knowledge
 * source (round A, §4).
 * - db.ts + migrations/ — this service's database `memory`: the navigation tables. Migration 16
 * dropped the old store's tables when round B retired the crawl → embed → seed pipeline (§9.1).
 */
export namespace memory {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.navBoundaryApprove = this.navBoundaryApprove.bind(this)
            this.navDocuments = this.navDocuments.bind(this)
            this.navFrontier = this.navFrontier.bind(this)
            this.navFrontierDoors = this.navFrontierDoors.bind(this)
            this.navGates = this.navGates.bind(this)
            this.navGatesAdd = this.navGatesAdd.bind(this)
            this.navPipeline = this.navPipeline.bind(this)
            this.navPipelineRetry = this.navPipelineRetry.bind(this)
            this.navProviders = this.navProviders.bind(this)
            this.navRoomDetail = this.navRoomDetail.bind(this)
            this.navRooms = this.navRooms.bind(this)
            this.navRunAbort = this.navRunAbort.bind(this)
            this.navRunStatus = this.navRunStatus.bind(this)
            this.navRuns = this.navRuns.bind(this)
            this.navRunsLaunch = this.navRunsLaunch.bind(this)
            this.navSearch = this.navSearch.bind(this)
            this.navStats = this.navStats.bind(this)
        }

        public async navBoundaryApprove(params: navigation.PostBoundaryApproveRequest): Promise<navigation.PostBoundaryApproveResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/navigation/boundary/approve`, JSON.stringify(params))
            return await resp.json() as navigation.PostBoundaryApproveResponse
        }

        public async navDocuments(params: navigation.GetDocumentsRequest): Promise<navigation.DocumentsPage> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:         params.limit === undefined ? undefined : String(params.limit),
                offset:        params.offset === undefined ? undefined : String(params.offset),
                provider:      params.provider,
                titleContains: params.titleContains,
                urlPrefix:     params.urlPrefix,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/documents`, undefined, {query})
            return await resp.json() as navigation.DocumentsPage
        }

        public async navFrontier(params: navigation.ProviderScopedRequest): Promise<navigation.GetFrontierResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                provider: params.provider,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/frontier`, undefined, {query})
            return await resp.json() as navigation.GetFrontierResponse
        }

        public async navFrontierDoors(params: navigation.GetFrontierDoorsRequest): Promise<navigation.FrontierDoorsPage> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
                prefix:   params.prefix,
                provider: params.provider,
                side:     String(params.side),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/frontier/doors`, undefined, {query})
            return await resp.json() as navigation.FrontierDoorsPage
        }

        public async navGates(params: navigation.ProviderScopedRequest): Promise<navigation.GetGatesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                provider: params.provider,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/gates`, undefined, {query})
            return await resp.json() as navigation.GetGatesResponse
        }

        public async navGatesAdd(params: navigation.PostGatesRequest): Promise<navigation.PostGatesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/navigation/gates`, JSON.stringify(params))
            return await resp.json() as navigation.PostGatesResponse
        }

        public async navPipeline(params: navigation.ProviderScopedRequest): Promise<navigation.GetPipelineResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                provider: params.provider,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/pipeline`, undefined, {query})
            return await resp.json() as navigation.GetPipelineResponse
        }

        public async navPipelineRetry(): Promise<navigation.PostPipelineRetryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/navigation/pipeline/retry`)
            return await resp.json() as navigation.PostPipelineRetryResponse
        }

        public async navProviders(): Promise<navigation.GetProvidersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/providers`)
            return await resp.json() as navigation.GetProvidersResponse
        }

        public async navRoomDetail(params: navigation.GetRoomDetailRequest): Promise<navigation.GetRoomDetailResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                key:      params.key,
                provider: params.provider,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/rooms/detail`, undefined, {query})
            return await resp.json() as navigation.GetRoomDetailResponse
        }

        public async navRooms(params: navigation.GetRoomsRequest): Promise<navigation.RoomsPage> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                changedSince:       params.changedSince,
                hasUnfollowedDoors: params.hasUnfollowedDoors === undefined ? undefined : String(params.hasUnfollowedDoors),
                limit:              params.limit === undefined ? undefined : String(params.limit),
                offset:             params.offset === undefined ? undefined : String(params.offset),
                provider:           params.provider,
                urlPrefix:          params.urlPrefix,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/rooms`, undefined, {query})
            return await resp.json() as navigation.RoomsPage
        }

        public async navRunAbort(id: string): Promise<navigation.PostRunAbortResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/navigation/runs/${encodeURIComponent(id)}/abort`)
            return await resp.json() as navigation.PostRunAbortResponse
        }

        public async navRunStatus(id: string): Promise<navigation.GetRunStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/runs/${encodeURIComponent(id)}`)
            return await resp.json() as navigation.GetRunStatusResponse
        }

        public async navRuns(params: navigation.GetRunsRequest): Promise<navigation.GetRunsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
                provider: params.provider,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/runs`, undefined, {query})
            return await resp.json() as navigation.GetRunsResponse
        }

        public async navRunsLaunch(params: navigation.PostRunsRequest): Promise<navigation.PostRunsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/navigation/runs`, JSON.stringify(params))
            return await resp.json() as navigation.PostRunsResponse
        }

        public async navSearch(params: navigation.PostSearchRequest): Promise<navigation.PostSearchResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/navigation/search`, JSON.stringify(params))
            return await resp.json() as navigation.PostSearchResponse
        }

        public async navStats(params: navigation.ProviderScopedRequest): Promise<navigation.GetStatsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                provider: params.provider,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/navigation/stats`, undefined, {query})
            return await resp.json() as navigation.GetStatsResponse
        }
    }
}

/**
 * The change planner (docs/claude/plans.md): plans drafted from a prompt, agreed in the Changes tab,
 * run step by step over the Zoom API, the browser or the user. Its OpenAPI graph (`openapi/`) is
 * the drafter's source of API operations. Its `auth: true` endpoints and stream are the user's: a
 * service token is turned away (auth/lib/service-gate.ts); the brain's `draftPlan` / `revisePlan`
 * and the cron's `tick` are private and carry no auth, so the gate leaves them alone.
 */
export namespace plans {
    export interface Actor {
        id: string
        email: string
    }

    /**
     * A browser step the agent carries out in Zoom's web portal (execution/agent-api.ts): a document plan's task the API
     * cannot do, in place of a recipe. What the agent is told of it.
     */
    export interface AgentStepSpec {
        task: AgentTask
    }

    export interface AgentTask {
        key: string
        name: string
        kind: string
        action: string
        text: string
        context: string[]
        relations: {
            to: string
            how: string
            name: string
            task: boolean
        }[]
        sources: {
            unit: string
            section: string
            text: string
        }[]
        questions: string[]
        assumptions: string[]
        /**
         * What was tried before the agent (the API's call and why it did not take): told the agent, not part of what a recording is kept by.
         */
        tried?: string
    }

    export interface ApiStepSpec {
        "operation_id": string
        method: Method
        /**
         * Templated: `/phone/call_queues/{{create_queue.id}}/members`.
         */
        path: string

        body?: { [key: string]: any }
        query?: { [key: string]: any }
        /**
         * Zoom's alternatives: any one grants the call.
         */
        scopes: string[]

        /**
         * The granular scopes the credential lacks (D7); empty when held.
         */
        "missing_scopes": string[]

        /**
         * Where the created id sits in the response; `id` when absent.
         */
        "id_path"?: string

        /**
         * The body's top-level fields and the JSON type the operation's schema declares for each; readiness checks the body against it.
         */
        "body_types"?: { [key: string]: string }

        /**
         * A step a document's routing made (origin `document`): the task it does, for the reads before its call and the evaluation of a failed one.
         */
        task?: DocumentTask
    }

    export interface ApprovePlanRequest {
        version: number
        /**
         * D11: approve and start the run in one call (the chat card).
         */
        run?: boolean

        /**
         * D19: open the browser panel while browser steps run.
         */
        "watch_browser"?: boolean
    }

    export interface ApprovePlanResponse {
        plan: PlanView
        "run_id"?: string
    }

    export interface Blocker {
        code: BlockerCode
        "step_key"?: string
        detail: string
        names?: string[]
    }

    export type BlockerCode = "no_steps" | "dag_invalid" | "missing_inputs" | "missing_scopes" | "write_access" | "no_recipe" | "placeholder_unresolved" | "channel_unavailable" | "body_invalid"

    export interface BrowserStepSpec {
        "setting_id": string
        "recipe_id": string
        parameters: { [key: string]: any }
    }

    export type Channel = "api" | "browser" | "human"

    export interface ChannelAvailability {
        channel: Channel
        ok: boolean
        reason?: string
    }

    export interface CreatePlanRequest {
        /**
         * What to draft from (D1, D10): a `prompt` (with the conversation it came from), read as a request document; a report `fix` (`action`: a curated fix id); an
         * `inferred_fix` for a report suggestion (`text`, the insights' `hint`, `confirm` once the user
         * accepted a low-confidence mapping).
         */
        source: {
            kind: "prompt" | "fix" | "inferred_fix"
            prompt?: string
            "conversation_id"?: string
            action?: string
            text?: string
            hint?: string
            confirm?: boolean
        }
    }

    export interface CreatePlanResponse {
        status: "plan" | "document" | "needs_confirm" | "not_fixable"
        plan?: PlanView
        /**
         * `document`: a prompt is a request document being read; its page follows it (docs/plans/chat-on-document-pipeline.md).
         */
        document?: document.DocumentView

        /**
         * `needs_confirm`: the inferred mapping to confirm (send again with `confirm: true`).
         */
        preview?: {
            label: string
            settingId: string
            target: string
        }

        /**
         * `needs_confirm`, `not_fixable`: what the user reads.
         */
        message?: string
    }

    /**
     * The task a document's step does (plans/document/route.ts): what the evaluation of a failed call is shown, what is read first.
     */
    export interface DocumentTask {
        /**
         * The task's object and what is done to it.
         */
        key: string

        name: string
        kind: string
        action: string
        /**
         * What the task asks, as the decomposer wrote it.
         */
        text: string

        asks: {
            attribute: string
            value: string
        }[]
        /**
         * The calls that change the task's object (`METHOD /path: summary; body: fields`), so a call the evaluation says to make first is one the API has.
         */
        calls: string[]

        /**
         * What routing read of the account for it (the ids of the objects it uses).
         */
        known: string[]

        /**
         * A create's own object, looked for by its exact name before the call: there already, the evaluation decides.
         */
        self: NamedRead | null

        /**
         * The ids its call uses of objects that steps off the API make, and of objects it only uses, read before the call.
         */
        reads: NamedRead[]

        /**
         * What the browser agent is told should the API hand the step over (the browser is on): the experiment's lane goes on there.
         */
        browser?: AgentTask
    }

    export interface HumanStepDoneRequest {
        note?: string
    }

    export interface HumanStepSpec {
        instructions: string
        /**
         * The settings map's entry for "Take me there".
         */
        "settings_map_entry_id"?: string
    }

    export interface ListPlansRequest {
        status?: PlanStatus
        limit?: number
        offset?: number
    }

    export interface ListPlansResponse {
        plans: PlanSummary[]
        total: number
        hasMore: boolean
    }

    export type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE"

    /**
     * An object the step reads the id of by its exact name, from its resource's list, before its call.
     */
    export interface NamedRead {
        /**
         * The step (or the used object) whose output the id becomes: `{{<key>.id}}`.
         */
        key: string

        kind: string
        name: string
        /**
         * The list's GET path.
         */
        path: string
    }

    export interface PlanChatMessage {
        role: string
        content: string
    }

    export interface PlanChatRequest {
        message: string
        /**
         * What the admin's page shows as they write (the chat bubble sends its text), so the chat can speak to it.
         */
        screen?: string
    }

    export interface PlanChatResponse {
        messages: PlanChatMessage[]
        /**
         * Whether the history is kept (the conversation is the caller's); when not, `messages` is this exchange alone.
         */
        kept: boolean

        plan: PlanView
        /**
         * The request read again with the message: the document whose plan replaces this one.
         */
        "document_id"?: string

        /**
         * A page of the Zoom web portal the message asked to see: the page opens it in the browser panel.
         */
        "navigate_url"?: string
    }

    export type PlanOrigin = "chat" | "tab" | "fix" | "inferred_fix" | "revert" | "document"

    export interface PlanResponse {
        plan: PlanView
    }

    export type PlanStatus = "draft" | "ready" | "approved" | "scheduled" | "running" | "completed" | "failed" | "reverting" | "reverted" | "revert_partial" | "cancelled"

    /**
     * A step as an update sends it: the position is its place in the list.
     */
    export interface PlanStepInput {
        key: string
        title: string
        description: string
        channel: Channel
        "depends_on": string[]
        inputs: StepInput[]
        api?: ApiStepSpec
        browser?: BrowserStepSpec
        agent?: AgentStepSpec
        human?: HumanStepSpec
        verify?: VerifySpec
        revert?: RevertSpec
    }

    export interface PlanStepView {
        "channels_available": ChannelAvailability[]
        "missing_inputs": string[]
        "missing_scopes": string[]
        run: StepRunView | null
        key: string
        position: number
        title: string
        description: string
        channel: Channel
        "depends_on": string[]
        inputs: StepInput[]
        api?: ApiStepSpec
        browser?: BrowserStepSpec
        /**
         * A browser step the agent carries out instead of a recipe (document plans).
         */
        agent?: AgentStepSpec

        human?: HumanStepSpec
        verify?: VerifySpec
        revert?: RevertSpec
    }

    export interface PlanStreamHandshake {
        /**
         * One plan to follow; absent for the tenant's list.
         */
        planId?: string
    }

    export interface PlanStreamMessage {
        type: "plan" | "summary" | "ping"
        plan?: PlanView
        summary?: PlanSummary
    }

    export interface PlanSummary {
        id: string
        title: string
        status: PlanStatus
        version: number
        origin: PlanOrigin
        "created_by": Actor
        "approved_by"?: Actor
        "scheduled_at"?: string
        "step_count": number
        channels: Channel[]
        "created_at": string
        "updated_at": string
    }

    export interface PlanView {
        id: string
        title: string
        goal: string
        status: PlanStatus
        version: number
        origin: PlanOrigin
        "conversation_id"?: string
        /**
         * The document the plan was made from (an upload, a chat request, the tab's prompt), when it was.
         */
        "document_id"?: string

        "reverts_plan_id"?: string
        /**
         * The completed revert of this plan, once one ran (D10): no second Revert.
         */
        "reverted_by_plan_id"?: string

        "created_by": Actor
        "approved_by"?: Actor
        "scheduled_at"?: string
        "watch_browser": boolean
        readiness: Readiness
        schedulable: Schedulable
        "missing_scopes": string[]
        steps: PlanStepView[]
        /**
         * The latest run, a dry run included (`kind` says which); null before any.
         */
        run: RunView | null

        revert?: RevertView
        /**
         * One line on how the plan ended (outcome.ts), once it has.
         */
        "outcome_line"?: string

        /**
         * The scopes ZAC added to the Zoom app for this plan (a revert's: for the plan it reverts), still on it and taken back.
         */
        "added_scopes"?: {
            live: string[]
            removed: string[]
        }

        "created_at": string
        "updated_at": string
    }

    export interface Readiness {
        ok: boolean
        blockers: Blocker[]
    }

    export interface ReplanResponse {
        /**
         * The document that reads the request again; the page follows it to its plan.
         */
        "document_id": string
    }

    export interface RevertAction {
        kind: RevertKind
        method?: Method
        path?: string
        /**
         * patch: the GET the prior values were read from, its placeholders resolved (a revert plan's step reads its own prior there).
         */
        "read_path"?: string

        body?: { [key: string]: any }
        "setting_id"?: string
        parameters?: { [key: string]: any }
        instructions?: string
        /**
         * delete: the scopes its operation takes (any one), added to the app when Zoom refuses the call for one.
         */
        scopes?: string[]

        /**
         * agent: the undo the browser agent is given; `instructions` stays the person's should it hand back.
         */
        "agent_task"?: AgentTask
    }

    /**
     * agent: the browser agent undoes what an agent step did (plans/executors/browser.ts), the person when it cannot.
     */
    export type RevertKind = "delete" | "patch" | "recipe" | "agent" | "manual"

    export interface RevertOutcome {
        "step_key": string
        outcome: "reverted" | "failed" | "manual"
        message: string
        instructions?: string
        "settings_map_entry_id"?: string
    }

    export interface RevertSpec {
        kind: RevertKind
        /**
         * delete: the DELETE sibling's path, templated with `{{self.id}}`.
         */
        path?: string

        /**
         * delete: the DELETE operation's id and scopes (any-of), for the revert plan's step; patch: the prior GET's.
         */
        "operation_id"?: string

        scopes?: string[]
        /**
         * patch: the GET to read the prior values from before the call.
         */
        "read_path"?: string

        /**
         * manual: what the user does to undo it.
         */
        instructions?: string
    }

    export type RevertStatus = "pending" | "completed" | "failed" | "manual"

    export interface RevertView {
        status: "reverting" | "reverted" | "revert_partial"
        steps: RevertOutcome[]
    }

    export interface RunFailure {
        "step_key"?: string
        code: string
        message: string
    }

    export type RunKind = "run" | "dry_run"

    export interface RunResponse {
        "run_id": string
    }

    export type RunStatus = "running" | "completed" | "failed" | "reverting" | "reverted" | "revert_partial"

    export type RunTrigger = "manual" | "scheduled"

    export interface RunView {
        id: string
        kind: RunKind
        trigger: RunTrigger
        status: RunStatus
        "plan_version": number
        "started_by": string
        failure?: RunFailure
        "started_at": string
        "finished_at"?: string
        steps: StepRunView[]
    }

    export interface RunsResponse {
        runs: RunView[]
    }

    export interface Schedulable {
        ok: boolean
        reason?: string
    }

    export interface SchedulePlanRequest {
        /**
         * ISO 8601.
         */
        at: string
    }

    /**
     * A value the draft could not fill (D16): shown on the node, Approve disabled until filled.
     */
    export interface StepInput {
        name: string
        label: string
        required: boolean
        value: any
        /**
         * Where the value goes: `api.body.site_id`, `api.path_params.callQueueId`, `browser.parameters.name`.
         */
        bind: string

        /**
         * What an account read offered when it found none or several.
         */
        candidates?: string[]
    }

    export type StepRunStatus = "pending" | "running" | "waiting_human" | "completed" | "failed" | "skipped"

    export interface StepRunView {
        "step_key": string
        status: StepRunStatus
        /**
         * The channel the step ran on: the browser for an API step the API handed over (plans/runner.ts `settle`).
         */
        channel: Channel

        request?: { [key: string]: any }
        response?: { [key: string]: any }
        output?: { [key: string]: any }
        prior?: { [key: string]: any }
        verification?: Verification
        "revert_action"?: RevertAction
        "revert_status"?: RevertStatus
        "revert_result"?: { [key: string]: any }
        error?: RunFailure
        "human_done_by"?: string
        "started_at"?: string
        "finished_at"?: string
    }

    /**
     * What is under way now: a document reading or planning, a plan running or reverting.
     */
    export interface TraceActive {
        kind: TraceKind
        id: string
        title: string
        stage: TraceStage
        /**
         * The last line said of it.
         */
        line: string | null
    }

    export interface TraceEntry {
        id: number
        at: string
        kind: TraceKind
        "ref_id": string | null
        title: string
        stage: TraceStage
        line: string
        step: string | null
        facts: TraceFacts | null
    }

    /**
     * What a pipeline box shows: its calls and their cost, what it made, and its sub-calls (ask's gap, verdict, type, section).
     */
    export interface TraceFacts {
        calls?: number
        usd?: number
        detail?: string
        parts?: { [key: string]: number }
        /**
         * The round a reading starts (on its `start` line).
         */
        round?: number
    }

    export type TraceKind = "document" | "plan"

    export interface TraceRequest {
        /**
         * The last line's id the panel holds; 0 for the latest lines.
         */
        after?: number
    }

    export interface TraceResponse {
        active: TraceActive[]
        entries: TraceEntry[]
    }

    /**
     * The pipeline's stages, in order: a document is read, asks, is planned; a plan runs, and may be reverted.
     */
    export type TraceStage = "read" | "ask" | "plan" | "run" | "revert"

    export interface TraceStepsResponse {
        /**
         * Its lines that name a diagram box, in the order said.
         */
        steps: TraceEntry[]
    }

    export interface UpdatePlanRequest {
        "expected_version": number
        title?: string
        steps: PlanStepInput[]
    }

    export interface Verification {
        passed: boolean
        checks: {
            field: string
            expected: any
            actual: any
            passed: boolean
        }[]
        skipped?: string
    }

    export interface VerifyCheck {
        /**
         * A dot path into the entity the GET returns.
         */
        field: string

        /**
         * A dot path into the request body the value must equal; or `expected`.
         */
        source?: string

        expected?: any
    }

    export interface VerifySpec {
        method: "GET"
        /**
         * Templated; `{{self.id}}` is the step's own created id.
         */
        path: string

        checks: VerifyCheck[]
        /**
         * The GET's scopes (any one): asked for with the plan's, so the check can read (live 2026-11-03: refused mid-run).
         */
        scopes?: string[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.answerDocument = this.answerDocument.bind(this)
            this.approvePlan = this.approvePlan.bind(this)
            this.cancelPlan = this.cancelPlan.bind(this)
            this.createPlan = this.createPlan.bind(this)
            this.dryRunPlan = this.dryRunPlan.bind(this)
            this.getDocument = this.getDocument.bind(this)
            this.getPlan = this.getPlan.bind(this)
            this.getPlanChat = this.getPlanChat.bind(this)
            this.getTrace = this.getTrace.bind(this)
            this.getTraceSteps = this.getTraceSteps.bind(this)
            this.listDocuments = this.listDocuments.bind(this)
            this.listPlans = this.listPlans.bind(this)
            this.listRuns = this.listRuns.bind(this)
            this.markHumanStepDone = this.markHumanStepDone.bind(this)
            this.planFromDocument = this.planFromDocument.bind(this)
            this.planStream = this.planStream.bind(this)
            this.replanPlan = this.replanPlan.bind(this)
            this.revertAgain = this.revertAgain.bind(this)
            this.revertPlan = this.revertPlan.bind(this)
            this.runPlan = this.runPlan.bind(this)
            this.schedulePlan = this.schedulePlan.bind(this)
            this.sendPlanChat = this.sendPlanChat.bind(this)
            this.unschedulePlan = this.unschedulePlan.bind(this)
            this.updatePlan = this.updatePlan.bind(this)
            this.uploadDocument = this.uploadDocument.bind(this)
        }

        public async answerDocument(id: string, params: document.AnswerDocumentRequest): Promise<document.DocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/documents/${encodeURIComponent(id)}/answers`, JSON.stringify(params))
            return await resp.json() as document.DocumentResponse
        }

        public async approvePlan(id: string, params: ApprovePlanRequest): Promise<ApprovePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/approve`, JSON.stringify(params))
            return await resp.json() as ApprovePlanResponse
        }

        public async cancelPlan(id: string): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/cancel`)
            return await resp.json() as PlanResponse
        }

        public async createPlan(params: CreatePlanRequest): Promise<CreatePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans`, JSON.stringify(params))
            return await resp.json() as CreatePlanResponse
        }

        public async dryRunPlan(id: string): Promise<RunResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/dry-run`)
            return await resp.json() as RunResponse
        }

        public async getDocument(id: string): Promise<document.DocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/documents/${encodeURIComponent(id)}`)
            return await resp.json() as document.DocumentResponse
        }

        public async getPlan(id: string): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/${encodeURIComponent(id)}`)
            return await resp.json() as PlanResponse
        }

        public async getPlanChat(id: string): Promise<PlanChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/${encodeURIComponent(id)}/chat`)
            return await resp.json() as PlanChatResponse
        }

        public async getTrace(params: TraceRequest): Promise<TraceResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                after: params.after === undefined ? undefined : String(params.after),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/trace`, undefined, {query})
            return await resp.json() as TraceResponse
        }

        /**
         * The diagram of one document or plan: the boxes its lines lit.
         */
        public async getTraceSteps(id: string): Promise<TraceStepsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/trace/steps/${encodeURIComponent(id)}`)
            return await resp.json() as TraceStepsResponse
        }

        public async listDocuments(params: document.DocumentsRequest): Promise<document.DocumentsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/documents`, undefined, {query})
            return await resp.json() as document.DocumentsResponse
        }

        public async listPlans(params: ListPlansRequest): Promise<ListPlansResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
                status: params.status === undefined ? undefined : String(params.status),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans`, undefined, {query})
            return await resp.json() as ListPlansResponse
        }

        public async listRuns(id: string): Promise<RunsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/${encodeURIComponent(id)}/runs`)
            return await resp.json() as RunsResponse
        }

        public async markHumanStepDone(id: string, key: string, params: HumanStepDoneRequest): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/steps/${encodeURIComponent(key)}/done`, JSON.stringify(params))
            return await resp.json() as PlanResponse
        }

        public async planFromDocument(id: string, params: document.PlanDocumentRequest): Promise<document.DocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/documents/${encodeURIComponent(id)}/plan`, JSON.stringify(params))
            return await resp.json() as document.DocumentResponse
        }

        public async planStream(params: PlanStreamHandshake): Promise<StreamIn<PlanStreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                planId: params.planId,
            })

            return await this.baseClient.createStreamIn(`/plans/stream`, {query})
        }

        public async replanPlan(id: string): Promise<ReplanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/replan`)
            return await resp.json() as ReplanResponse
        }

        /**
         * A partly reverted plan's failed undos tried again (runner `revertAgain`): the plan goes back to reverting and ends
         * reverted, or partly reverted again with what still failed.
         */
        public async revertAgain(id: string): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/revert-again`)
            return await resp.json() as PlanResponse
        }

        /**
         * D10: a completed plan's revert is a new plan of the undo actions, approved and run like any. A
         * plan is reverted once: a revert already under way is the one returned; a completed one is final.
         */
        public async revertPlan(id: string): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/revert`)
            return await resp.json() as PlanResponse
        }

        public async runPlan(id: string): Promise<RunResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/run`)
            return await resp.json() as RunResponse
        }

        public async schedulePlan(id: string, params: SchedulePlanRequest): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/schedule`, JSON.stringify(params))
            return await resp.json() as PlanResponse
        }

        public async sendPlanChat(id: string, params: PlanChatRequest): Promise<PlanChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/${encodeURIComponent(id)}/chat`, JSON.stringify(params))
            return await resp.json() as PlanChatResponse
        }

        public async unschedulePlan(id: string): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/plans/${encodeURIComponent(id)}/schedule`)
            return await resp.json() as PlanResponse
        }

        public async updatePlan(id: string, params: UpdatePlanRequest): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/plans/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as PlanResponse
        }

        /**
         * bodyLimit, 7 MiB: a document of MAX_DOCUMENT_BYTES (5 MiB) as base64 is 6.7 MiB; Encore reads the option as a literal.
         */
        public async uploadDocument(params: document.UploadDocumentRequest): Promise<document.DocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans/documents`, JSON.stringify(params))
            return await resp.json() as document.DocumentResponse
        }
    }
}

/**
 * REPL service provides a sandboxed JavaScript runtime for chat agents
 */
export namespace repl {
    export interface ApiCallRecord {
        method: string
        path: string
        status: number
        durationMs: number
    }

    export interface ExecuteRequest {
        code: string
        mode: SandboxMode
        tenantId: string
        userId: string
        conversationId?: string
        requestId?: string
    }

    export interface ExecuteResponse {
        success: boolean
        result: any
        logs: string[]
        apiCalls: ApiCallRecord[]
        error?: string
        durationMs: number
    }

    /**
     * Sandbox access modes — controls which APIs are available. Both read only: every change is a plan (D10).
     */
    export type SandboxMode = "knowledge" | "research"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.execute = this.execute.bind(this)
        }

        /**
         * Execute JavaScript in a sandboxed REPL environment
         */
        public async execute(params: ExecuteRequest): Promise<ExecuteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repl/execute`, JSON.stringify(params))
            return await resp.json() as ExecuteResponse
        }
    }
}

/**
 * Validation service provides AI agents for testing Contact Center configurations
 */
export namespace validation {
    export interface ApiCheck {
        name: string
        endpoint: string
        method: string
        expectedStatus: number
        expectedFields?: string[]
        expectedValues?: { [key: string]: any }
    }

    export interface ApiValidationConfig {
        checks: ApiCheck[]
    }

    export interface ApiValidationResult {
        type: "api"
        apiDetails?: {
            checksPerformed: number
            checksPassed: number
            checksFailed: number
        }
        id: string
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export interface ChatValidationConfig {
        widgetUrl: string
        scenario: string
        testMessages: string[]
        expectedResponses: string[]
        maxWaitTime: number
    }

    export interface ChatValidationResult {
        type: "chat"
        chatDetails?: {
            sessionId?: string
            messageCount: number
            responseTime: number
            agentConnected?: string
        }
        id: string
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export interface MenuOption {
        dtmf: string
        description: string
        expectedQueue?: string
    }

    export interface RunApiValidationRequest {
        planId?: string
        stageId?: string
        config: ApiValidationConfig
    }

    export interface RunChatValidationRequest {
        planId?: string
        stageId?: string
        config: ChatValidationConfig
    }

    export interface RunVoiceValidationRequest {
        planId?: string
        stageId?: string
        config: VoiceValidationConfig
    }

    export interface ValidationResult {
        id: string
        type: ValidationType
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export interface ValidationStepResult {
        step: string
        status: "passed" | "failed" | "warning" | "skipped"
        message?: string
        expected?: string
        actual?: string
        duration?: number
    }

    export type ValidationType = "voice" | "chat" | "api" | "manual"

    export interface VoiceValidationConfig {
        phoneNumber: string
        scenario: string
        expectedRouting: string
        maxWaitTime: number
        menuOptions?: MenuOption[]
    }

    export interface VoiceValidationResult {
        type: "voice"
        callDetails?: {
            callId?: string
            duration: number
            queueReached?: string
            agentConnected?: string
            ivrPath: string[]
        }
        id: string
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getValidationResult = this.getValidationResult.bind(this)
            this.getValidationResults = this.getValidationResults.bind(this)
            this.validateApi = this.validateApi.bind(this)
            this.validateChat = this.validateChat.bind(this)
            this.validateVoice = this.validateVoice.bind(this)
        }

        /**
         * Get a specific validation result by ID
         */
        public async getValidationResult(id: string): Promise<{
    result: ValidationResult
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/validation/results/${encodeURIComponent(id)}`)
            return await resp.json() as {
    result: ValidationResult
}
        }

        /**
         * Get validation results for a plan
         */
        public async getValidationResults(params: {
    planId?: string
    stageId?: string
    limit?: number
}): Promise<{
    results: ValidationResult[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:   params.limit === undefined ? undefined : String(params.limit),
                planId:  params.planId,
                stageId: params.stageId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/validation/results`, undefined, {query})
            return await resp.json() as {
    results: ValidationResult[]
}
        }

        /**
         * Run API validation to verify configuration via API calls
         */
        public async validateApi(params: RunApiValidationRequest): Promise<ApiValidationResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/validation/api`, JSON.stringify(params))
            return await resp.json() as ApiValidationResult
        }

        /**
         * Run chat validation to test webchat flows
         */
        public async validateChat(params: RunChatValidationRequest): Promise<ChatValidationResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/validation/chat`, JSON.stringify(params))
            return await resp.json() as ChatValidationResult
        }

        /**
         * Run voice validation to test IVR and call routing
         */
        public async validateVoice(params: RunVoiceValidationRequest): Promise<VoiceValidationResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/validation/voice`, JSON.stringify(params))
            return await resp.json() as VoiceValidationResult
        }
    }
}

/**
 * Zoom service handles all Zoom API interactions
 */
export namespace zoom {
    export interface ApiRequest {
        method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE"
        endpoint: string
        data?: { [key: string]: any }
    }

    export interface ApiRequest {
        method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE"
        endpoint: string
        data?: { [key: string]: any }
    }

    export interface ApiResponse {
        data: any
        status: number
    }

    export interface ResourceListResponse {
        resources: {
            id: string
            name: string
            type: string
            properties: { [key: string]: any }
        }[]
        nextPageToken?: string
        total?: number
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.createQueue = this.createQueue.bind(this)
            this.createScorecard = this.createScorecard.bind(this)
            this.createSkill = this.createSkill.bind(this)
            this.deleteQueue = this.deleteQueue.bind(this)
            this.executeBatch = this.executeBatch.bind(this)
            this.executeRequest = this.executeRequest.bind(this)
            this.getAccount = this.getAccount.bind(this)
            this.getAccountInsights = this.getAccountInsights.bind(this)
            this.getAllUsersWithServices = this.getAllUsersWithServices.bind(this)
            this.getContactCenterSummary = this.getContactCenterSummary.bind(this)
            this.getDashboard = this.getDashboard.bind(this)
            this.getFlows = this.getFlows.bind(this)
            this.getLicenseReport = this.getLicenseReport.bind(this)
            this.getProfile = this.getProfile.bind(this)
            this.getQueue = this.getQueue.bind(this)
            this.getQueues = this.getQueues.bind(this)
            this.getSkills = this.getSkills.bind(this)
            this.getUsers = this.getUsers.bind(this)
            this.listAddressBooks = this.listAddressBooks.bind(this)
            this.listFlows = this.listFlows.bind(this)
            this.listQueues = this.listQueues.bind(this)
            this.listScorecards = this.listScorecards.bind(this)
            this.listSkills = this.listSkills.bind(this)
            this.searchUsers = this.searchUsers.bind(this)
            this.updateQueue = this.updateQueue.bind(this)
        }

        /**
         * Create queue
         */
        public async createQueue(params: {
    name: string
    channel: string
    settings?: { [key: string]: any }
}): Promise<{
    id: string
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/contact-center/queues`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    resource: any
}
        }

        /**
         * Create scorecard
         */
        public async createScorecard(params: {
    name: string
    description?: string
    sections: {
        name: string
        weight: number
        questions: any[]
    }[]
}): Promise<{
    id: string
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/quality-management/scorecards`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    resource: any
}
        }

        /**
         * Create skill
         */
        public async createSkill(params: {
    name: string
    description?: string
}): Promise<{
    id: string
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/contact-center/skills`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    resource: any
}
        }

        /**
         * Delete queue
         */
        public async deleteQueue(id: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/zoom/contact-center/queues/${encodeURIComponent(id)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Batch execute multiple API requests
         */
        public async executeBatch(params: {
    requests: ApiRequest[]
}): Promise<{
    results: (ApiResponse | {
        error: string
    })[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/batch`, JSON.stringify(params))
            return await resp.json() as {
    results: (ApiResponse | {
        error: string
    })[]
}
        }

        /**
         * Generic Zoom API proxy - execute any API call
         */
        public async executeRequest(params: ApiRequest): Promise<ApiResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/request`, JSON.stringify(params))
            return await resp.json() as ApiResponse
        }

        /**
         * Get account information
         */
        public async getAccount(): Promise<account.GetAccountInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/info`)
            return await resp.json() as account.GetAccountInfoResponse
        }

        /**
         * Get account insights and metrics
         */
        public async getAccountInsights(): Promise<account.GetInsightsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/insights`)
            return await resp.json() as account.GetInsightsResponse
        }

        /**
         * Get all users with their service assignments
         */
        public async getAllUsersWithServices(): Promise<account.GetUsersWithServicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/users/services`)
            return await resp.json() as account.GetUsersWithServicesResponse
        }

        /**
         * Get Contact Center summary
         */
        public async getContactCenterSummary(): Promise<account.ContactCenterSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/contact-center`)
            return await resp.json() as account.ContactCenterSummary
        }

        /**
         * Get dashboard data
         */
        public async getDashboard(params: {
    /**
     * Get dashboard data
     */
    accountId?: string
}): Promise<account.GetDashboardResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/dashboard`, undefined, {query})
            return await resp.json() as account.GetDashboardResponse
        }

        /**
         * List flows
         */
        public async getFlows(): Promise<account.ListFlowsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/flows`)
            return await resp.json() as account.ListFlowsResponse
        }

        /**
         * Get license utilization report
         */
        public async getLicenseReport(params: {
    /**
     * Get license utilization report
     */
    accountId?: string
}): Promise<account.GetLicenseReportResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/license-report`, undefined, {query})
            return await resp.json() as account.GetLicenseReportResponse
        }

        /**
         * Get comprehensive Zoom account profile
         */
        public async getProfile(): Promise<{
    /**
     * Get comprehensive Zoom account profile
     */
    profile: account.ZoomAccountProfile
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/profile`)
            return await resp.json() as {
    /**
     * Get comprehensive Zoom account profile
     */
    profile: account.ZoomAccountProfile
}
        }

        /**
         * Get queue by ID
         */
        public async getQueue(id: string): Promise<{
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/queues/${encodeURIComponent(id)}`)
            return await resp.json() as {
    resource: any
}
        }

        /**
         * List queues
         */
        public async getQueues(): Promise<account.ListQueuesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/queues`)
            return await resp.json() as account.ListQueuesResponse
        }

        /**
         * List skills
         */
        public async getSkills(): Promise<account.ListSkillsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/skills`)
            return await resp.json() as account.ListSkillsResponse
        }

        /**
         * List Contact Center users
         */
        public async getUsers(params: account.ListUsersRequest): Promise<account.ListUsersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
                search: params.search,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/users`, undefined, {query})
            return await resp.json() as account.ListUsersResponse
        }

        /**
         * List address books
         */
        public async listAddressBooks(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/address-books`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List flows
         */
        public async listFlows(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/flows`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List queues
         */
        public async listQueues(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/queues`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List scorecards
         */
        public async listScorecards(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/quality-management/scorecards`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List skills
         */
        public async listSkills(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/skills`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * Search users
         */
        public async searchUsers(params: {
    /**
     * Search users
     */
    query: string

    /**
     * Search users
     */
    limit?: number
}): Promise<account.ListUsersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
                query: params.query,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/users/search`, undefined, {query})
            return await resp.json() as account.ListUsersResponse
        }

        /**
         * Update queue
         */
        public async updateQueue(id: string, params: {
    updates: { [key: string]: any }
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/zoom/contact-center/queues/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }
    }
}

/**
 * Canonical graph of the Zoom admin portal.
 * 
 * Owns the zoom_map FalkorDB graph: :Page / :Modal nodes connected by
 * :NAV and :CONTAINS relationships. Consumed by recipe/ (validator) and
 * execution/ (terminal-node assertion) services.
 * 
 * Substrate for non-inference Zoom navigation — Card pytfYjwI (A1) of the
 * feat/non-inference-execution feature branch.
 */
export namespace zoom_map {
    export type ActionType = "click" | "fill" | "select"

    export type EdgeRelation = "NAV" | "CONTAINS" | "HAS_FIELD"

    export interface GraphEdge {
        from: string
        to: string
        relation: EdgeRelation
        "action_type": ActionType | null
        "target_role": string | null
        "target_name": string | null
        "target_testid": string | null
        /**
         * Optional row-scoping anchor for enterprise SaaS row patterns where
         * each row has generic action labels ("Edit", "Delete"). When set, the
         * executor scopes the role+name search to the ancestor row of the
         * element matching this text/heading, avoiding Playwright strict-mode
         * violations and wrong-row matches.
         * 
         * Resolution model (executor.ts):
         * - target_anchor present → anchor-scoped locator is the ONLY tier
         * tried. Falls through to selector_unresolved if the anchor text
         * or the scoped role+name fails to resolve. No fallback to
         * Tier 1/Tier 2 — the anchor was added precisely because those
         * tiers were ambiguous.
         * - target_anchor null → existing 3-tier role+name → testid → xpath.
         */
        "target_anchor": string | null

        label: string | null
    }

    export interface GraphNode {
        id: string
        kind: NodeKind
        "url_pattern": string
        "primary_heading": string
        "form_signature": string
        terminal: boolean
        "screenshot_ref": string | null
    }

    export interface GraphSnapshot {
        nodes: GraphNode[]
        edges: GraphEdge[]
    }

    export type NodeKind = "Page" | "Modal" | "Field"

    export interface NodeWithOutgoing {
        node: GraphNode
        outgoing: GraphEdge[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getGraph = this.getGraph.bind(this)
            this.getNode = this.getNode.bind(this)
            this.getSubgraph = this.getSubgraph.bind(this)
        }

        /**
         * Get the full zoom-map graph snapshot (all :Page, :Modal, :Field nodes + all edges).
         */
        public async getGraph(): Promise<GraphSnapshot> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom-map/graph`)
            return await resp.json() as GraphSnapshot
        }

        /**
         * Get one node by id + its outgoing edges. Returns 404 if the node doesn't exist.
         */
        public async getNode(id: string): Promise<NodeWithOutgoing> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom-map/node/${encodeURIComponent(id)}`)
            return await resp.json() as NodeWithOutgoing
        }

        /**
         * Get reachable subgraph from a root node up to a bounded depth (1-10).
         */
        public async getSubgraph(params: {
    /**
     * Get reachable subgraph from a root node up to a bounded depth (1-10).
     */
    rootId: string

    /**
     * Get reachable subgraph from a root node up to a bounded depth (1-10).
     */
    depth?: number
}): Promise<GraphSnapshot> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                depth:  params.depth === undefined ? undefined : String(params.depth),
                rootId: params.rootId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom-map/subgraph`, undefined, {query})
            return await resp.json() as GraphSnapshot
        }
    }
}

export namespace account {
    export interface ContactCenterSummary {
        queues: {
            total: number
            byChannel: { [key: string]: number }
        }
        skills: {
            total: number
        }
        flows: {
            total: number
            byStatus: { [key: string]: number }
        }
        agents: {
            total: number
        }
    }

    export interface GetAccountInfoResponse {
        account: ZoomAccountInfo
    }

    export interface GetDashboardResponse {
        dashboard: ZoomDashboardData
    }

    export interface GetInsightsResponse {
        insights: ZoomAccountInsights
    }

    export interface GetLicenseReportResponse {
        report: LicenseUtilizationReport
    }

    export interface GetUsersWithServicesResponse {
        users: ZoomUserWithServices[]
        total: number
        summary: {
            totalUsers: number
            byLicense: { [key: string]: number }
        }
        scopeErrors: string[]
    }

    export interface LicenseUtilizationReport {
        generatedAt: string
        account: {
            name: string
            type: string
            accountNumber?: string
        }
        plans: {
            name: string
            type: string
            seats: number
            used: number
            utilizationPct: number
        }[]
        userCounts: {
            total: number
            licensed: number
            basic: number
            inactive30: number
            inactive60: number
            inactive90: number
            neverLoggedIn: number
        }
        inactiveUsers: {
            email: string
            name: string
            type: "licensed" | "basic"
            department?: string
            role?: string
            lastLogin?: string
            daysSinceLogin: number
            addOns: string[]
        }[]
        addOnUtilization: {
            name: string
            licensedUsers: number
            activeUsers: number
            unusedCount: number
            utilizationPct: number
        }[]
        savings: {
            category: string
            description: string
            affectedUsers: number
            potentialAction: string
        }[]
    }

    export interface ListFlowsResponse {
        flows: ZoomFlowInfo[]
        total: number
    }

    export interface ListQueuesResponse {
        queues: ZoomQueueInfo[]
        total: number
    }

    export interface ListSkillsResponse {
        skills: ZoomSkillInfo[]
        total: number
    }

    export interface ListUsersRequest {
        limit?: number
        offset?: number
        search?: string
    }

    export interface ListUsersResponse {
        users: ZoomUser[]
        total: number
        hasMore: boolean
    }

    export interface ZoomAccountInfo {
        id: string
        name: string
        ownerEmail?: string
        type?: string
        planType?: string
        userCount?: number
        contactCenterEnabled: boolean
    }

    export interface ZoomAccountInsights {
        account: ZoomAccountInfo
        queues: number
        skills: number
        flows: number
        agents: number
        licenses: {
            total: number
            assigned: number
            available: number
        }
        products: ZoomProductAccess
    }

    export interface ZoomAccountProfile {
        /**
         * Identity
         */
        account: {
            id: string
            name: string
            type: string | "Pro" | "Business" | "Enterprise"
            owner: string
            vanityUrl?: string
        }

        /**
         * Licensing
         */
        subscription: {
            startDate: string
            endDate: string
            daysRemaining: number
        }

        plans: ZoomPlanInfo[]
        /**
         * Users
         */
        users: {
            total: number
            licensed: number
            basic: number
            stale: number
        }

        /**
         * Product Adoption
         */
        adoption: {
            meetings: {
                totalMeetings: number
                uniqueHosts: number
                avgParticipants: number
            }
            aiCompanion: {
                adoptionRate: number
                lowAdoptionUsers: {
                    email: string
                    rate: number
                }[]
            }
            teamChat: {
                activeUsers: number
                totalMessages: number
            }
            phone: {
                usersAssigned: number
                usersWithNumbers: number
            }
            contactCenter: {
                usersAssigned: number
                queuesConfigured: number
                flowsPublished: number
            }
        }

        /**
         * Issues
         */
        issues: ZoomProfileIssue[]
    }

    export interface ZoomDailyActivity {
        date: string
        meetings: {
            count: number
            participants: number
            aiCompanionRate: number
        }
        chat: {
            messages: number
            activeUsers: number
        }
        phone: {
            calls: number
            minutes: number
        }
        contactCenter: {
            interactions: number
            avgHandleTime: number
        }
        clips: {
            created: number
            views: number
        }
    }

    export interface ZoomDashboardData {
        account: {
            name: string
            type: string
            owner: string
        }
        /**
         * Key metrics (top row)
         */
        metrics: {
            adoptionScore: ZoomMetricWithTrend
            licenseUtilization: {
                value: number
                used: number
                total: number
                direction: "up" | "down" | "stable"
            }
            aiCompanion: ZoomMetricWithTrend
            seatsUsed: {
                used: number
                total: number
                warning: boolean
            }
            issues: {
                total: number
                high: number
                medium: number
                low: number
                change: number
                direction: "up" | "down" | "stable"
            }
        }

        /**
         * Product activity chart (180 days: -90 to +90)
         */
        activity: {
            past: ZoomDailyActivity[]
            future: ZoomFutureActivity[]
        }

        /**
         * Product adoption rates
         */
        adoption: {
            product: string
            rate: number
            trend: "up" | "down" | "stable"
        }[]

        /**
         * User product matrix
         */
        userMatrix: ZoomUserProductRow[]

        /**
         * Active issues
         */
        issues: ZoomProfileIssue[]

        /**
         * Recommendations
         */
        recommendations: ZoomRecommendation[]
    }

    export interface ZoomFlowInfo {
        id: string
        name: string
        type: string
        status: string
        channel: string
    }

    export interface ZoomFutureActivity {
        date: string
        meetings: {
            scheduled: number
            recurring: number
        }
    }

    export interface ZoomMetricWithTrend {
        value: number
        change: number
        direction: "up" | "down" | "stable"
    }

    export interface ZoomPlanInfo {
        name: string
        type: string | "addon" | "phone" | "zcc"
        seats: number
        used: number
        status: string | "trial"
        renewalDate?: string
    }

    export interface ZoomProductAccess {
        contactCenter: boolean
        virtualAgent: boolean
        qualityManagement: boolean
        workforceManagement: boolean
        expertAssist: boolean
        outboundDialer: boolean
    }

    export interface ZoomProductScore {
        score: number
        intensity: "high" | "medium" | "low" | "none"
    }

    export interface ZoomProfileIssue {
        severity: "high" | "medium" | "low"
        type: string
        message: string
        recommendation?: string
        chatPrompt?: string
    }

    export interface ZoomQueueInfo {
        id: string
        name: string
        channel: string
        status: string
        agentCount: number
    }

    export interface ZoomRecommendation {
        id: string
        type: "adoption" | "enablement" | "optimization" | "configuration" | "training"
        priority: "high" | "medium" | "low"
        title: string
        description: string
        impact: string
        product: string
        affectedUsers?: string[]
        actions: ZoomRecommendationAction[]
    }

    export interface ZoomRecommendationAction {
        label: string
        type: "chat" | "link" | "dismiss"
        chatPrompt?: string
        url?: string
    }

    export interface ZoomSkillInfo {
        id: string
        name: string
        description?: string
        agentCount: number
    }

    export interface ZoomUser {
        id: string
        email: string
        name: string
        role: string
        status: string
        queues: string[]
        skills: string[]
    }

    export interface ZoomUserProductRow {
        email: string
        name: string
        type: "licensed" | "basic"
        products: {
            meetings: ZoomProductScore
            aiCompanion: ZoomProductScore
            chat: ZoomProductScore
            phone: ZoomProductScore
            contactCenter: ZoomProductScore
            clips: ZoomProductScore
            rooms: ZoomProductScore
        }
        overallScore: number
    }

    export interface ZoomUserWithServices {
        id: string
        email: string
        name: string
        role: string
        status: string
        department?: string
        licenses: string[]
    }
}

export namespace config {
    export interface DependencyPath {
        nodes: ResourceNode[]
        relationships: string[]
    }

    export interface ResourceNode {
        type: string
        resourceId: string
        name: string
        properties: { [key: string]: any }
    }
}

export namespace document {
    export interface AnswerDocumentRequest {
        /**
         * Each answer and the question (q<n>) or assumption (s<n>) of the last round it answers.
         */
        answers: GivenAnswer[]
    }

    export interface DocumentAnswer {
        id: string
        /**
         * The question or assumption it answers.
         */
        answers: string

        text: string
    }

    export interface DocumentAssumption {
        /**
         * s1 onwards.
         */
        id: string

        /**
         * What is left to Zoom, for the author.
         */
        text: string

        about: string
    }

    export type DocumentKind = "pdf" | "markdown" | "text"

    export interface DocumentObject {
        key: string
        name: string
        kind: string
        action: string
    }

    export interface DocumentQuestion {
        /**
         * q1 onwards.
         */
        id: string

        text: string
        /**
         * The field or kind it asks about.
         */
        about: string

        /**
         * ZAC's suggested answer and why; null when only the author can know it.
         */
        suggestion: {
            text: string
            why: string
        } | null

        /**
         * The objects one answer covers, by name, when it is asked for several (the same question folded): the page says so
         * (live 2026-11-03: asked for ZAC-Sales, answered for ZAC-Support too, unseen).
         */
        objects?: string[]
    }

    export interface DocumentResponse {
        document: DocumentView
    }

    /**
     * Where a document came from: a file uploaded, or a request typed in the chat or the Changes tab's prompt.
     */
    export type DocumentSource = "upload" | "chat" | "tab"

    export type DocumentStatus = "decomposing" | "asking" | "planning" | "planned" | "failed"

    export interface DocumentSummary {
        id: string
        filename: string
        source: DocumentSource
        status: DocumentStatus
        round: number
        "plan_id": string | null
        "updated_at": string
    }

    export interface DocumentView {
        id: string
        filename: string
        kind: DocumentKind
        source: DocumentSource
        "conversation_id": string | null
        /**
         * A follow-up's document: the one it was read again in place of.
         */
        supersedes: string | null

        /**
         * The follow-up's document that replaced this one: it takes no answers and makes no plan.
         */
        "superseded_by": string | null

        status: DocumentStatus
        /**
         * The rounds done, and the most a document takes.
         */
        round: number

        "max_rounds": number
        /**
         * Whether it takes answers now: asking or stopped, a round left.
         */
        "can_answer": boolean

        questions: DocumentQuestion[]
        assumptions: DocumentAssumption[]
        answers: DocumentAnswer[]
        objects: DocumentObject[]
        "plan_id": string | null
        /**
         * The routing's notes beside its plan (an id not read, a scope wanted).
         */
        notes: string[]

        error: string | null
        "cost_usd": number
        "created_at": string
        "updated_at": string
    }

    export interface DocumentsRequest {
        limit?: number
    }

    export interface DocumentsResponse {
        documents: DocumentSummary[]
    }

    /**
     * What the author sends back: what each answer answers (a question q<n> or an assumption s<n> of the last round) and its text.
     */
    export interface GivenAnswer {
        answers: string
        text: string
    }

    export interface PlanDocumentRequest {
        /**
         * Answers to the last round's questions (q<n>) or assumptions (s<n>), taken as decided: no round more.
         */
        answers?: GivenAnswer[]
    }

    export interface UploadDocumentRequest {
        filename: string
        /**
         * The file's bytes, base64.
         */
        "content_base64": string

        /**
         * Attached in the chat: the conversation, so a follow-up there reads it again (docs/plans/chat-on-document-pipeline.md).
         */
        "conversation_id"?: string
    }
}

export namespace lib {
    export interface AccountData {
        id: string
        name: string
        email: string
        type: number
        typeName: string
        picUrl?: string
        timezone?: string
        createdAt?: string
        vanityUrl?: string
        managedDomains?: string[]
        scopeWarning?: string
        ownerName?: string
        ownerPicUrl?: string
    }

    export interface ArchiveData {
        "_status": "provisioned" | "not_provisioned"
        totalFiles?: number
        totalSize?: number
    }

    export interface DailyUsage {
        date: string
        meetings: number
        participants: number
        meetingMinutes: number
        newUsers: number
        uniqueParticipants?: number
        participantDetails?: ParticipantDetail[]
    }

    export interface GroupSummary {
        id: string
        name: string
        totalMembers: number
    }

    export interface GroupsData {
        totalGroups: number
        groups: GroupSummary[]
    }

    export interface LiveMeetingsData {
        "_scope": Scope
        totalLive: number
        meetings: {
            uuid: string
            topic: string
            host: string
            startTime: string
            participants: number
            hasIssues: boolean
        }[]
    }

    export interface MarketplaceData {
        totalApps: number
        apps: {
            name: string
            status?: string
        }[]
    }

    export interface MeetingQualityData {
        "_scope": Scope
        totalMeetings: number
        qualityDistribution: {
            good: number
            fair: number
            poor: number
            bad: number
        }
        avgQualityScore?: number
        recentMeetings: {
            uuid: string
            topic: string
            startTime: string
            duration: number
            participants: number
            quality: string
        }[]
    }

    export interface MonthlyUsage {
        month: string
        meetings: number
        participants: number
        meetingMinutes: number
        newUsers: number
        uniqueParticipants?: number
        participantDetails?: ParticipantDetail[]
    }

    export interface NotAvailable {
        "_status": "not_available"
        message: string
    }

    export interface OperationLogsData {
        "_scope": Scope
        totalLogs: number
        logs: {
            operator: string
            action: string
            categoryType: string
            time: string
        }[]
    }

    /**
     * One ZAC Insights suggestion. `action` is a machine-actionable fix id
     * from mcp-zoom/fix-actions.ts (null/absent = no automated fix).
     */
    export interface OverviewSuggestion {
        text: string
        action?: string | null
        /**
         * True when this is a concrete account-settings change (not advisory). Only
         * actionable suggestions get a Fix button; when `action` is null the fix is
         * inferred (plans/draft/infer-fix.ts).
         */
        actionable?: boolean

        /**
         * Free-text hint naming the setting the suggestion targets — feeds inference.
         */
        settingHint?: string | null
    }

    export interface ParticipantDetail {
        email: string
        name: string
    }

    export interface PhoneCallLogsData {
        "_scope": Scope
        totalCalls: number
        avgDurationSeconds: number
        byDirection: {
            inbound: number
            outbound: number
        }
        recentCalls: {
            callerName?: string
            callerNumber?: string
            calleeName?: string
            calleeNumber?: string
            direction: string
            duration: number
            startTime: string
            callType?: string
        }[]
    }

    export interface PhoneData {
        "_status": "provisioned" | "not_provisioned"
        companyName?: string
        autoCallRecording?: boolean
        emergencyServiceEnabled?: boolean
        voicemailEnabled?: boolean
        totalUsers?: number
    }

    export interface PlansData {
        "_scope": Scope
        planBase?: {
            type: string
            hosts: number
        }
        planLargeMeeting?: {
            type: string
            hosts: number
        }[]
        planWebinar?: {
            type: string
            hosts: number
        }[]
        planZoomRooms?: {
            type: string
            hosts: number
        }
    }

    export interface QosMetrics {
        bitrate?: string
        latency?: string
        jitter?: string
        packetLoss?: string
        resolution?: string
        frameRate?: string
    }

    export interface RecordingsData {
        "_scope": Scope
        totalRecords: number
        totalSize: number
        cloudRecordings: {
            topic: string
            startTime: string
            duration: number
            totalSize: number
            recordingCount: number
        }[]
    }

    export interface RoleSummary {
        id: string
        name: string
        description?: string
        totalMembers: number
    }

    export interface RolesData {
        totalRoles: number
        roles: RoleSummary[]
    }

    export interface RoomMetricsData {
        "_scope": Scope
        totalRooms: number
        online: number
        offline: number
        issues: {
            roomName: string
            issue: string
        }[]
    }

    export interface RoomsData {
        "_status": "provisioned" | "not_provisioned"
        totalRooms?: number
        rooms?: {
            id: string
            name: string
            status: string
        }[]
    }

    export interface SatisfactionData {
        "_scope": Scope
        totalResponses: number
        goodCount: number
        notGoodCount: number
        goodPercent: number
        dateRange: {
            from: string
            to: string
        }
    }

    export type Scope = "admin" | "user"

    export interface SettingsData {
        "_scope": Scope
        security: {
            waitingRoom?: boolean
            requirePassword?: boolean
            embedPasswordInLink?: boolean
            e2eEncryption?: boolean
            signedLogin?: boolean
            approvedDomains?: string[]
        }
        meeting: {
            hostVideo?: boolean
            participantVideo?: boolean
            joinBeforeHost?: boolean
            muteUponEntry?: boolean
            autoRecording?: string
            screenSharing?: boolean
            whoCanShare?: string
            breakoutRoom?: boolean
        }
        recording: {
            localRecording?: boolean
            cloudRecording?: boolean
            autoDelete?: boolean
            autoDeleteDays?: number
            recordingDisclaimer?: boolean
        }
    }

    export interface TelephoneData {
        "_scope": Scope
        totalMinutes: number
        totalCalls: number
        byType: { [key: string]: number }
    }

    export interface TopMeeting {
        topic: string
        occurrences: number
        avgParticipants: number
        avgDuration: number
        totalDuration: number
        lastOccurred: string
        host: string
    }

    export interface UsageData {
        "_scope": Scope
        year: number
        month: number
        totalMeetings: number
        totalParticipants: number
        totalMeetingMinutes: number
        dailyBreakdown: DailyUsage[]
        monthlyBreakdown: MonthlyUsage[]
        topMeetings?: TopMeeting[]
    }

    export interface UserSummary {
        email: string
        name: string
        type: number
        typeName: string
        role?: string
        status?: string
        lastLogin?: string
        department?: string
    }

    export interface UsersData {
        "_scope": Scope
        totalRecords: number
        users: UserSummary[]
        byType: { [key: string]: number }
        byStatus: { [key: string]: number }
    }

    export interface ZoomOverviewData {
        fetchedAt: string
        scope: Scope
        account: AccountData
        settings: SettingsData
        plans: PlansData | NotAvailable
        users: UsersData
        roles: RolesData | NotAvailable
        groups: GroupsData | NotAvailable
        usage: UsageData | NotAvailable
        recordings: RecordingsData
        phone: PhoneData
        rooms: RoomsData
        marketplace: MarketplaceData | NotAvailable
        archive: ArchiveData
        meetingQuality?: MeetingQualityData | NotAvailable
        satisfaction?: SatisfactionData | NotAvailable
        phoneCallLogs?: PhoneCallLogsData | NotAvailable
        telephone?: TelephoneData | NotAvailable
        liveMeetings?: LiveMeetingsData | NotAvailable
        roomMetrics?: RoomMetricsData | NotAvailable
        operationLogs?: OperationLogsData | NotAvailable
        aiSummary?: {
            scores: {
                security: number
                adoption: number
                usage: number
                configuration: number
                overall: number
            }
            keyPoints: string[]
            suggestions: OverviewSuggestion[]
            overallEvaluation: string
        }
    }
}

export namespace navigation {
    export interface AffordanceNode {
        id: string
        type: AffordanceType
        scope: AffordanceScope
        "url_addressable": boolean
        href?: string
        "seed_source"?: SeedSource
        "side_effect": SideEffect
        label?: string
        haspopup?: string
        "chrome_block"?: string
        status: AffordanceStatus
        "anchor_json"?: string
        "match_count"?: number
        ordinal?: number
        depth?: number
        "doc_order"?: number
        "requires_json"?: string
        "blocked_reason"?: string
        "blocked_screenshot_ref"?: string
        "blocked_tier"?: number
        "lease_worker_id"?: string
        "lease_heartbeat"?: number
        "lease_ttl_ms"?: number
        "lease_prev_status"?: AffordanceStatus
    }

    export type AffordanceScope = "chrome" | "local" | "seed"

    export type AffordanceStatus = "discovered" | "in_progress" | "traversed" | "blocked" | "dead" | "approved"

    export type AffordanceType = "tab" | "link" | "menuitem" | "treeitem" | "button" | "seed"

    export type Aspect = "documentation" | "apis" | "settings"

    export type BoundaryAddedBy = "system" | "user"

    export interface BoundaryOutcome {
        prefix: string
        outcome: "inserted" | "already"
    }

    export interface BoundaryRow {
        prefix: string
        "added_by": BoundaryAddedBy
        "created_at": string
    }

    export interface ChainOutcome {
        id: number
        "provider_id": string
        /**
         * The drained run when the cycle included one; null on a retry or a refused drain.
         */
        "run_id": string | null

        trigger: ChainTrigger
        status: ChainStatus
        /**
         * The failed stage; null on done.
         */
        stage: LaneStage | null

        error: string | null
        /**
         * The pipeline report on done (extraction + embed counts + duration_ms); null on failed.
         */
        counts: { [key: string]: any } | null

        "started_at": string
        "finished_at": string
    }

    export type ChainStatus = "done" | "failed"

    /**
     * D76.iii (zac-073) — knowledge's ChainOutcome, mirrored: the durable record of one lane cycle.
     */
    export type ChainTrigger = "auto" | "retry"

    export type ChangeType = "initial" | "changed" | "vanished" | "restored"

    export interface ChromeBlockForRoom {
        key: string
        role: string
        name: string
        status: ChromeBlockStatus
        doors: DoorForRoom[]
    }

    export type ChromeBlockStatus = "candidate" | "confirmed"

    export interface ChunkDetail {
        id: string
        ordinal: number
        text: string
        "char_start": number
        "char_end": number
        "token_count": number
        embedded: boolean
    }

    export interface CrawlCaps {
        "max_depth"?: number
        "max_rooms"?: number
        "wall_clock_ms"?: number
        /**
         * Per-tier TierCaps keyed by tier name ('1b' | '2' | '3'). Spelled Record<string, unknown>
         * — the jsonb treatment contract_snapshot/stats already get — because the client generator
         * emits a quoted '1b' key as bare `1b?:` (invalid TypeScript) and refuses `| undefined`
         * inside a Record value.
         */
        tiers?: { [key: string]: any }
    }

    export type CrawlMode = "discovery" | "re-crawl" | "resume" | "extend" | "supervised"

    export interface CrawlRunRow {
        id: string
        "provider_id": string | null
        aspect: Aspect
        mode: CrawlMode
        seeds: string[] | null
        "seed_source": SeedSource | null
        boundary: string[] | null
        radius: number | null
        caps: CrawlCaps | null
        "engine_version": string | null
        "git_sha": string | null
        /**
         * zac-074/E6 — the engine subtree's tree hash at launch; null on rows before migration 15.
         */
        "engine_tree": string | null

        "contract_snapshot": { [key: string]: any } | null
        locale: string | null
        status: CrawlRunStatus
        "started_at": string
        "finished_at": string | null
        stats: { [key: string]: any } | null
    }

    export type CrawlRunStatus = "running" | "drained" | "cap_tripped" | "aborted" | "refused" | "crashed" | "halted_auth" | "halted_rate_limited" | "halted_suspect"

    /**
     * lane.ts's DivergenceAxis, mirrored.
     */
    export type DivergenceAxis = "embedding_rollback" | "history_missing_from_graph"

    export interface DocumentDetail {
        document: {
            id: string
            title: string
            "content_hash": string
            version: number
            "extracted_at": number
            "markdown_ref": string
            "token_count": number
        }
        markdown: string
        chunks: ChunkDetail[]
    }

    export interface DocumentListItem {
        id: string
        title: string
        "content_hash": string
        version: number
        "extracted_at": number
        "token_count": number
        "chunk_count": number
        "location_id": string
        "room_key": string
        "room_url": string
    }

    export interface DocumentsPage {
        total: number
        documents: DocumentListItem[]
    }

    export interface DoorForRoom {
        door: AffordanceNode
        "target_key": string | null
        "target_url": string | null
    }

    export interface EngineStats {
        "rooms_total": number
        "rooms_visited": number
        "doors_total": number
        "doors_traversed": number
        "doors_discovered": number
        "gates_total": number
        "last_run": CrawlRunRow | null
    }

    export interface FrontierDoorRow {
        "door_id": string
        href: string
        label: string | null
        depth: number | null
        "owner_url": string | null
    }

    export interface FrontierDoorsPage {
        total: number
        doors: FrontierDoorRow[]
    }

    export interface FrontierGroup {
        prefix: string
        "door_count": number
        "example_labels": string[]
        "max_depth": number | null
    }

    export interface GateOutcome {
        href: string
        state: "created" | "existing"
        source: string
    }

    export interface GateRow {
        "door_id": string
        href: string
        "seed_source": SeedSource
        status: AffordanceStatus
        explored: boolean
    }

    export interface GetDocumentsRequest {
        provider: string
        offset?: number
        limit?: number
        urlPrefix?: string
        titleContains?: string
    }

    export interface GetFrontierDoorsRequest {
        provider: string
        prefix: string
        side: "in" | "off"
        offset?: number
        limit?: number
    }

    export interface GetFrontierResponse {
        /**
         * The partition operand used — the UI shows what "in-boundary" currently means.
         */
        boundary: string[]

        "in_boundary": FrontierGroup[]
        "off_boundary": FrontierGroup[]
    }

    export interface GetGatesResponse {
        gates: GateRow[]
    }

    export interface GetPipelineResponse {
        lane: LaneState
        counts: KnowledgeStats
        divergence: boolean
        /**
         * D76.iv: the axes behind `divergence`; empty when false.
         */
        "divergence_axes": DivergenceAxis[]

        /**
         * D57's server half: lane.busy() — kills the UI's ACTIVE_LANE duplication.
         */
        active: boolean

        /**
         * D76.iii: the provider's newest durable cycle outcome; null until a first cycle ends.
         */
        "last_chain": ChainOutcome | null
    }

    export interface GetProvidersResponse {
        providers: ProviderWithBoundaries[]
    }

    export interface GetRoomDetailRequest {
        provider: string
        /**
         * Canonical room URL (the §6.2 spelling: a query param, not a path segment).
         */
        key: string
    }

    export interface GetRoomDetailResponse {
        room: LocationNode
        history: LocationHistoryRow[]
        doors: DoorForRoom[]
        chrome: ChromeBlockForRoom[]
        breadcrumb: PathHop[] | null
        document: DocumentDetail | null
    }

    export interface GetRoomsRequest {
        provider: string
        offset?: number
        limit?: number
        urlPrefix?: string
        hasUnfollowedDoors?: boolean
        /**
         * ISO instant — the handler's z.coerce.date turns it into the engine's Date operand.
         */
        changedSince?: string
    }

    export interface GetRunStatusResponse {
        run: RunListItem
        live: RunLiveCounts
        /**
         * D76.iii: this run's own chain outcome — null while draining or when no chain ran.
         */
        chain: ChainOutcome | null
    }

    export interface GetRunsRequest {
        provider: string
        offset?: number
        limit?: number
    }

    export interface GetRunsResponse {
        total: number
        runs: RunListItem[]
    }

    export interface GetStatsResponse {
        navigation: EngineStats
        knowledge: KnowledgeStats
    }

    export interface KnowledgeStats {
        documents: number
        chunks: number
        "chunks_missing_embedding": number
        "ledger_live_rows": number
        "ledger_embedded_rows": number
        "pending_extraction": number
        /**
         * D76.iv: scheduled history locations with no Location node — the one-sided-restore axis.
         */
        "history_locations_missing_from_graph": number

        "last_extraction": string | null
    }

    export type LaneStage = "drain" | PipelineStage

    export type LaneState = {
        state: "idle"
    } | {
        state: "draining"
        provider: string
        "started_at": string
    } | {
        state: PipelineStage
        provider: string
        "started_at": string
    } | {
        state: "failed"
        provider: string
        stage: LaneStage
        error: string
        "failed_at": string
    } | {
        state: "done"
        provider: string
        "run_id": string | null
        "drain_status": string | null
        "finished_at": string
    }

    export interface LocationHistoryRow {
        "history_id": number
        "location_id": string
        "crawl_run_id": string
        "content_hash": string
        "ax_payload_key": string | null
        "html_payload_key": string | null
        "settings_snapshot": { [key: string]: any } | null
        "valid_from": string
        "valid_to": string | null
        "last_seen": string
        "visit_count": number
        "diff_summary": { [key: string]: any } | null
        "change_type": ChangeType
        /**
         * §5.2 canonical entries — [entry, count] pairs; spelled as arrays because the Encore
         * analyzer does not support tuple types (wire-identical JSON either way).
         */
        fingerprint: (string | number)[][] | null

        evidence: { [key: string]: any } | null
    }

    export type LocationKind = "page" | "tab-panel" | "modal" | "inline-edit" | "wizard-step"

    export interface LocationNode {
        id: string
        key: string
        url: string
        kind: LocationKind
        "capture_ref"?: string
        status: LocationStatus
        "first_seen": number
        "last_visited"?: number
        "last_crawled_at"?: number
        "is_entry": boolean
        "is_template": boolean
        "vanished_at"?: number
        /**
         * zac-074/E7 — the main response's media type at the last tier-1a fold; absent on in-page rooms
         * and on rooms folded before E7.
         */
        "content_type"?: string

        "synthetic_name"?: boolean
        "url_pattern"?: string
        "fingerprint_json"?: string
        "fingerprint_size"?: number
        "structural_hash"?: string
        "frames_json"?: string
        "low_ax_fidelity"?: boolean
        virtualized?: boolean
    }

    export type LocationStatus = "discovered" | "visited" | "failed" | "skipped" | "gone"

    export interface PathHop {
        "room_key": string
        "room_url": string
        "via_label": string | null
        "via_href": string | null
        "via_seed": boolean
    }

    export type PipelineStage = "extracting" | "embedding" | "saving"

    export interface PostBoundaryApproveRequest {
        provider: string
        prefix: string
    }

    export interface PostBoundaryApproveResponse {
        outcomes: BoundaryOutcome[]
    }

    export interface PostGatesRequest {
        provider: string
        url: string
    }

    export interface PostGatesResponse {
        outcomes: GateOutcome[]
    }

    export interface PostPipelineRetryResponse {
        retrying: true
        lane: LaneState
    }

    export interface PostRunAbortResponse {
        aborting: true
    }

    export interface PostRunsRequest {
        provider: string
        boundary: string[]
        radius?: number
        "max_rooms"?: number
    }

    export interface PostRunsResponse {
        accepted: true
        lane: LaneState
    }

    export interface PostSearchRequest {
        provider: string
        query: string
        topK?: number
        urlPrefix?: string
    }

    export interface PostSearchResponse {
        results: SearchResult[]
    }

    export interface ProviderScopedRequest {
        provider: string
    }

    export interface ProviderScopedRequest {
        provider: string
    }

    export interface ProviderScopedRequest {
        provider: string
    }

    export interface ProviderScopedRequest {
        provider: string
    }

    export interface ProviderWithBoundaries {
        "provider_id": string
        "display_name": string
        boundaries: BoundaryRow[]
    }

    export interface RoomListItem {
        id: string
        key: string
        url: string
        kind: LocationKind
        status: LocationStatus
        "is_entry": boolean
        "doors_total": number
        "doors_followed": number
        "doors_unfollowed": number
        "visit_count": number | null
        "last_seen": string | null
        "change_type": ChangeType | null
    }

    export interface RoomsPage {
        total: number
        rooms: RoomListItem[]
    }

    export interface RunListItem {
        id: string
        "provider_id": string | null
        aspect: Aspect
        mode: CrawlMode
        seeds: string[] | null
        "seed_source": SeedSource | null
        boundary: string[] | null
        radius: number | null
        caps: CrawlCaps | null
        "engine_version": string | null
        "git_sha": string | null
        /**
         * zac-074/E6 — the engine subtree's tree hash at launch; null on rows before migration 15.
         */
        "engine_tree": string | null

        "contract_snapshot": { [key: string]: any } | null
        locale: string | null
        status: CrawlRunStatus
        "started_at": string
        "finished_at": string | null
        stats: { [key: string]: any } | null
        owned: boolean
        stale: boolean
    }

    export interface RunLiveCounts {
        "history_rows": number
        "walk_gestures": number
        "pacing_events": number
    }

    export interface SearchResult {
        rank: number
        score: number
        "chunk_id": string
        ordinal: number
        "chunk_text": string
        "document_id": string
        title: string
        "room_key": string
        "room_url": string
        breadcrumb: PathHop[] | null
    }

    export type SeedSource = "system" | "user"

    export type SideEffect = "read-only" | "mutating" | "committed_side_effect" | "unknown"
}

export namespace shared {
    export interface Artifact {
        id: string
        type: ArtifactType
        title?: string
        content: string
        metadata?: { [key: string]: any }
    }

    export type ArtifactType = "mermaid" | "code" | "table" | "insights" | "config" | "markdown" | "plan"
}

export namespace teleport {
    /**
     * How a teleport ended: highlighted or opened; a stop (the map's misses, the user's own moves, a busy or signed-out
     * browser); or a failure (a crash, a load that never came, the browser unavailable, an error).
     */
    export type OutcomeKind = "highlighted" | "opened" | "step-missing" | "element-missing" | "unconfirmed" | "taken-over" | "not-allowed" | "signed-out" | "busy" | "crashed" | "load-timeout" | "unavailable" | "error"
}



function encodeQuery(parts: Record<string, string | string[]>): string {
    const pairs: string[] = []
    for (const key in parts) {
        const val = (Array.isArray(parts[key]) ?  parts[key] : [parts[key]]) as string[]
        for (const v of val) {
            pairs.push(`${key}=${encodeURIComponent(v)}`)
        }
    }
    return pairs.join("&")
}

// makeRecord takes a record and strips any undefined values from it,
// and returns the same record with a narrower type.
// @ts-ignore - TS ignore because makeRecord is not always used
function makeRecord<K extends string | number | symbol, V>(record: Record<K, V | undefined>): Record<K, V> {
    for (const key in record) {
        if (record[key] === undefined) {
            delete record[key]
        }
    }
    return record as Record<K, V>
}

function encodeWebSocketHeaders(headers: Record<string, string>) {
    // url safe, no pad
    const base64encoded = btoa(JSON.stringify(headers))
      .replaceAll("=", "")
      .replaceAll("+", "-")
      .replaceAll("/", "_");
    return "encore.dev.headers." + base64encoded;
}

class WebSocketConnection {
    public ws: WebSocket;

    private hasUpdateHandlers: (() => void)[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        let protocols = ["encore-ws"];
        if (headers) {
            protocols.push(encodeWebSocketHeaders(headers))
        }

        this.ws = new WebSocket(url, protocols)

        this.on("error", () => {
            this.resolveHasUpdateHandlers();
        });

        this.on("close", () => {
            this.resolveHasUpdateHandlers();
        });
    }

    resolveHasUpdateHandlers() {
        const handlers = this.hasUpdateHandlers;
        this.hasUpdateHandlers = [];

        for (const handler of handlers) {
            handler()
        }
    }

    async hasUpdate() {
        // await until a new message have been received, or the socket is closed
        await new Promise((resolve) => {
            this.hasUpdateHandlers.push(() => resolve(null))
        });
    }

    on(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.addEventListener(type, handler);
    }

    off(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.removeEventListener(type, handler);
    }

    close() {
        this.ws.close();
    }
}

export class StreamInOut<Request, Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamIn<Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamOut<Request, Response> {
    public socket: WebSocketConnection;
    private responseValue: Promise<Response>;

    constructor(url: string, headers?: Record<string, string>) {
        let responseResolver: (_: any) => void;
        this.responseValue = new Promise((resolve) => responseResolver = resolve);

        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            responseResolver(JSON.parse(event.data))
        });
    }

    async response(): Promise<Response> {
        return this.responseValue;
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }
}
// CallParameters is the type of the parameters to a method call, but require headers to be a Record type
type CallParameters = Omit<RequestInit, "method" | "body" | "headers"> & {
    /** Headers to be sent with the request */
    headers?: Record<string, string>

    /** Query parameters to be sent with the request */
    query?: Record<string, string | string[]>
}

// AuthDataGenerator is a function that returns a new instance of the authentication data required by this API
export type AuthDataGenerator = () =>
  | auth.AuthParams
  | Promise<auth.AuthParams | undefined>
  | undefined;

// A fetcher is the prototype for the inbuilt Fetch function
export type Fetcher = typeof fetch;

const boundFetch = fetch.bind(this);

class BaseClient {
    readonly baseURL: string
    readonly fetcher: Fetcher
    readonly headers: Record<string, string>
    readonly requestInit: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }
    readonly authGenerator?: AuthDataGenerator

    constructor(baseURL: string, options: ClientOptions) {
        this.baseURL = baseURL
        this.headers = {}

        // Add User-Agent header if the script is running in the server
        // because browsers do not allow setting User-Agent headers to requests
        if (!BROWSER) {
            this.headers["User-Agent"] = "zac-2w8i-Generated-TS-Client (Encore/v1.58.4)";
        }

        this.requestInit = options.requestInit ?? {};

        // Setup what fetch function we'll be using in the base client
        if (options.fetcher !== undefined) {
            this.fetcher = options.fetcher
        } else {
            this.fetcher = boundFetch
        }

        // Setup an authentication data generator using the auth data token option
        if (options.auth !== undefined) {
            const auth = options.auth
            if (typeof auth === "function") {
                this.authGenerator = auth
            } else {
                this.authGenerator = () => auth
            }
        }
    }

    async getAuthData(): Promise<CallParameters | undefined> {
        let authData: auth.AuthParams | undefined;

        // If authorization data generator is present, call it and add the returned data to the request
        if (this.authGenerator) {
            const mayBePromise = this.authGenerator();
            if (mayBePromise instanceof Promise) {
                authData = await mayBePromise;
            } else {
                authData = mayBePromise;
            }
        }

        if (authData) {
            const data: CallParameters = {};

            data.headers = makeRecord<string, string>({
                authorization: authData.authorization,
                "x-tenant-id": authData.tenantId,
            });

            return data;
        }

        return undefined;
    }

    // createStreamInOut sets up a stream to a streaming API endpoint.
    async createStreamInOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamInOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamInOut(this.baseURL + path + queryString, headers);
    }

    // createStreamIn sets up a stream to a streaming API endpoint.
    async createStreamIn<Response>(path: string, params?: CallParameters): Promise<StreamIn<Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamIn(this.baseURL + path + queryString, headers);
    }

    // createStreamOut sets up a stream to a streaming API endpoint.
    async createStreamOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamOut(this.baseURL + path + queryString, headers);
    }

    // callTypedAPI makes an API call, defaulting content type to "application/json"
    public async callTypedAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        return this.callAPI(method, path, body, {
            ...params,
            headers: { "Content-Type": "application/json", ...params?.headers }
        });
    }

    // callAPI is used by each generated API method to actually make the request
    public async callAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        let { query, headers, ...rest } = params ?? {}
        const init = {
            ...this.requestInit,
            ...rest,
            method,
            body: body ?? null,
        }

        // Merge our headers with any predefined headers
        init.headers = {...this.headers, ...init.headers, ...headers}

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                init.headers = {...init.headers, ...authData.headers};
            }
        }

        // Make the actual request
        const queryString = query ? '?' + encodeQuery(query) : ''
        const response = await this.fetcher(this.baseURL+path+queryString, init)

        // handle any error responses
        if (!response.ok) {
            // try and get the error message from the response body
            let body: APIErrorResponse = { code: ErrCode.Unknown, message: `request failed: status ${response.status}` }

            // if we can get the structured error we should, otherwise give a best effort
            try {
                const text = await response.text()

                try {
                    const jsonBody = JSON.parse(text)
                    if (isAPIErrorResponse(jsonBody)) {
                        body = jsonBody
                    } else {
                        body.message += ": " + JSON.stringify(jsonBody)
                    }
                } catch {
                    body.message += ": " + text
                }
            } catch (e) {
                // otherwise we just append the text to the error message
                body.message += ": " + String(e)
            }

            throw new APIError(response.status, body)
        }

        return response
    }
}

/**
 * APIErrorDetails represents the response from an Encore API in the case of an error
 */
interface APIErrorResponse {
    code: ErrCode
    message: string
    details?: any
}

function isAPIErrorResponse(err: any): err is APIErrorResponse {
    return (
        err !== undefined && err !== null &&
        isErrCode(err.code) &&
        typeof(err.message) === "string" &&
        (err.details === undefined || err.details === null || typeof(err.details) === "object")
    )
}

function isErrCode(code: any): code is ErrCode {
    return code !== undefined && Object.values(ErrCode).includes(code)
}

/**
 * APIError represents a structured error as returned from an Encore application.
 */
export class APIError extends Error {
    /**
     * The HTTP status code associated with the error.
     */
    public readonly status: number

    /**
     * The Encore error code
     */
    public readonly code: ErrCode

    /**
     * The error details
     */
    public readonly details?: any

    constructor(status: number, response: APIErrorResponse) {
        // extending errors causes issues after you construct them, unless you apply the following fixes
        super(response.message);

        // set error name as constructor name, make it not enumerable to keep native Error behavior
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        Object.defineProperty(this, 'name', {
            value:        'APIError',
            enumerable:   false,
            configurable: true,
        })

        // fix the prototype chain
        if ((Object as any).setPrototypeOf == undefined) {
            (this as any).__proto__ = APIError.prototype
        } else {
            Object.setPrototypeOf(this, APIError.prototype);
        }

        // capture a stack trace
        if ((Error as any).captureStackTrace !== undefined) {
            (Error as any).captureStackTrace(this, this.constructor);
        }

        this.status = status
        this.code = response.code
        this.details = response.details
    }
}

/**
 * Typeguard allowing use of an APIError's fields'
 */
export function isAPIError(err: any): err is APIError {
    return err instanceof APIError;
}

export enum ErrCode {
    /**
     * OK indicates the operation was successful.
     */
    OK = "ok",

    /**
     * Canceled indicates the operation was canceled (typically by the caller).
     *
     * Encore will generate this error code when cancellation is requested.
     */
    Canceled = "canceled",

    /**
     * Unknown error. An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space. Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * Encore will generate this error code in the above two mentioned cases.
     */
    Unknown = "unknown",

    /**
     * InvalidArgument indicates client specified an invalid argument.
     * Note that this differs from FailedPrecondition. It indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * This error code will not be generated by the gRPC framework.
     */
    InvalidArgument = "invalid_argument",

    /**
     * DeadlineExceeded means operation expired before completion.
     * For operations that change the state of the system, this error may be
     * returned even if the operation has completed successfully. For
     * example, a successful response from a server could have been delayed
     * long enough for the deadline to expire.
     *
     * The gRPC framework will generate this error code when the deadline is
     * exceeded.
     */
    DeadlineExceeded = "deadline_exceeded",

    /**
     * NotFound means some requested entity (e.g., file or directory) was
     * not found.
     *
     * This error code will not be generated by the gRPC framework.
     */
    NotFound = "not_found",

    /**
     * AlreadyExists means an attempt to create an entity failed because one
     * already exists.
     *
     * This error code will not be generated by the gRPC framework.
     */
    AlreadyExists = "already_exists",

    /**
     * PermissionDenied indicates the caller does not have permission to
     * execute the specified operation. It must not be used for rejections
     * caused by exhausting some resource (use ResourceExhausted
     * instead for those errors). It must not be
     * used if the caller cannot be identified (use Unauthenticated
     * instead for those errors).
     *
     * This error code will not be generated by the gRPC core framework,
     * but expect authentication middleware to use it.
     */
    PermissionDenied = "permission_denied",

    /**
     * ResourceExhausted indicates some resource has been exhausted, perhaps
     * a per-user quota, or perhaps the entire file system is out of space.
     *
     * This error code will be generated by the gRPC framework in
     * out-of-memory and server overload situations, or when a message is
     * larger than the configured maximum size.
     */
    ResourceExhausted = "resource_exhausted",

    /**
     * FailedPrecondition indicates operation was rejected because the
     * system is not in a state required for the operation's execution.
     * For example, directory to be deleted may be non-empty, an rmdir
     * operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FailedPrecondition, Aborted, and Unavailable:
     *  (a) Use Unavailable if the client can retry just the failing call.
     *  (b) Use Aborted if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FailedPrecondition if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FailedPrecondition
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FailedPrecondition if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     *
     * This error code will not be generated by the gRPC framework.
     */
    FailedPrecondition = "failed_precondition",

    /**
     * Aborted indicates the operation was aborted, typically due to a
     * concurrency issue like sequencer check failures, transaction aborts,
     * etc.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     */
    Aborted = "aborted",

    /**
     * OutOfRange means operation was attempted past the valid range.
     * E.g., seeking or reading past end of file.
     *
     * Unlike InvalidArgument, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate InvalidArgument if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OutOfRange if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FailedPrecondition and
     * OutOfRange. We recommend using OutOfRange (the more specific
     * error) when it applies so that callers who are iterating through
     * a space can easily look for an OutOfRange error to detect when
     * they are done.
     *
     * This error code will not be generated by the gRPC framework.
     */
    OutOfRange = "out_of_range",

    /**
     * Unimplemented indicates operation is not implemented or not
     * supported/enabled in this service.
     *
     * This error code will be generated by the gRPC framework. Most
     * commonly, you will see this error code when a method implementation
     * is missing on the server. It can also be generated for unknown
     * compression algorithms or a disagreement as to whether an RPC should
     * be streaming.
     */
    Unimplemented = "unimplemented",

    /**
     * Internal errors. Means some invariants expected by underlying
     * system has been broken. If you see one of these errors,
     * something is very broken.
     *
     * This error code will be generated by the gRPC framework in several
     * internal error conditions.
     */
    Internal = "internal",

    /**
     * Unavailable indicates the service is currently unavailable.
     * This is a most likely a transient condition and may be corrected
     * by retrying with a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     *
     * This error code will be generated by the gRPC framework during
     * abrupt shutdown of a server process or network connection.
     */
    Unavailable = "unavailable",

    /**
     * DataLoss indicates unrecoverable data loss or corruption.
     *
     * This error code will not be generated by the gRPC framework.
     */
    DataLoss = "data_loss",

    /**
     * Unauthenticated indicates the request does not have valid
     * authentication credentials for the operation.
     *
     * The gRPC framework will generate this error code when the
     * authentication metadata is invalid or a Credentials callback fails,
     * but also expect authentication middleware to generate it.
     */
    Unauthenticated = "unauthenticated",
}
